import { jsxs as j, jsx as N } from "react/jsx-runtime";
import V, { forwardRef as je, useState as Q, useRef as R, useEffect as U, createContext as We, useLayoutEffect as ct, useId as ut, useMemo as ee, useCallback as Oe } from "react";
import { S as ft } from "./swiper-nav-button-iMuGhpnI.mjs";
import { c as q } from "./tw-cn-mXgPecoF.mjs";
import { D as ne } from "./dot-badge-tMztb4kJ.mjs";
import { C as pt } from "./chip-6i9l0Qwr.mjs";
import { e as mt } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as Z } from "./index-BpNK5r1N.mjs";
function ze(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function Ce(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((s) => i.indexOf(s) < 0).forEach((s) => {
    typeof t[s] > "u" ? t[s] = e[s] : ze(e[s]) && ze(t[s]) && Object.keys(e[s]).length > 0 && Ce(t[s], e[s]);
  });
}
const Xe = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function ie() {
  const t = typeof document < "u" ? document : {};
  return Ce(t, Xe), t;
}
const ht = {
  document: Xe,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function k() {
  const t = typeof window < "u" ? window : {};
  return Ce(t, ht), t;
}
function gt(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function vt(t) {
  const e = t;
  Object.keys(e).forEach((i) => {
    try {
      e[i] = null;
    } catch {
    }
    try {
      delete e[i];
    } catch {
    }
  });
}
function qe(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function de() {
  return Date.now();
}
function wt(t) {
  const e = k();
  let i;
  return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
}
function St(t, e) {
  e === void 0 && (e = "x");
  const i = k();
  let s, n, r;
  const l = wt(t);
  return i.WebKitCSSMatrix ? (n = l.transform || l.webkitTransform, n.split(",").length > 6 && (n = n.split(", ").map((a) => a.replace(",", ".")).join(", ")), r = new i.WebKitCSSMatrix(n === "none" ? "" : n)) : (r = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = r.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? n = r.m41 : s.length === 16 ? n = parseFloat(s[12]) : n = parseFloat(s[4])), e === "y" && (i.WebKitCSSMatrix ? n = r.m42 : s.length === 16 ? n = parseFloat(s[13]) : n = parseFloat(s[5])), n || 0;
}
function ae(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function bt(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function H() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const s = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (s != null && !bt(s)) {
      const n = Object.keys(Object(s)).filter((r) => e.indexOf(r) < 0);
      for (let r = 0, l = n.length; r < l; r += 1) {
        const a = n[r], o = Object.getOwnPropertyDescriptor(s, a);
        o !== void 0 && o.enumerable && (ae(t[a]) && ae(s[a]) ? s[a].__swiper__ ? t[a] = s[a] : H(t[a], s[a]) : !ae(t[a]) && ae(s[a]) ? (t[a] = {}, s[a].__swiper__ ? t[a] = s[a] : H(t[a], s[a])) : t[a] = s[a]);
      }
    }
  }
  return t;
}
function le(t, e, i) {
  t.style.setProperty(e, i);
}
function Ye(t) {
  let {
    swiper: e,
    targetPosition: i,
    side: s
  } = t;
  const n = k(), r = -e.translate;
  let l = null, a;
  const o = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
  const d = i > r ? "next" : "prev", c = (f, h) => d === "next" && f >= h || d === "prev" && f <= h, u = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), l === null && (l = a);
    const f = Math.max(Math.min((a - l) / o, 1), 0), h = 0.5 - Math.cos(f * Math.PI) / 2;
    let p = r + h * (i - r);
    if (c(p, i) && (p = i), e.wrapperEl.scrollTo({
      [s]: p
    }), c(p, i)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [s]: p
        });
      }), n.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = n.requestAnimationFrame(u);
  };
  u();
}
function Y(t, e) {
  e === void 0 && (e = "");
  const i = k(), s = [...t.children];
  return i.HTMLSlotElement && t instanceof HTMLSlotElement && s.push(...t.assignedElements()), e ? s.filter((n) => n.matches(e)) : s;
}
function Tt(t, e) {
  const i = [e];
  for (; i.length > 0; ) {
    const s = i.shift();
    if (t === s)
      return !0;
    i.push(...s.children, ...s.shadowRoot ? s.shadowRoot.children : [], ...s.assignedElements ? s.assignedElements() : []);
  }
}
function xt(t, e) {
  const i = k();
  let s = e.contains(t);
  return !s && i.HTMLSlotElement && e instanceof HTMLSlotElement && (s = [...e.assignedElements()].includes(t), s || (s = Tt(t, e))), s;
}
function ce(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function xe(t, e) {
  e === void 0 && (e = []);
  const i = document.createElement(t);
  return i.classList.add(...Array.isArray(e) ? e : gt(e)), i;
}
function yt(t, e) {
  const i = [];
  for (; t.previousElementSibling; ) {
    const s = t.previousElementSibling;
    e ? s.matches(e) && i.push(s) : i.push(s), t = s;
  }
  return i;
}
function Et(t, e) {
  const i = [];
  for (; t.nextElementSibling; ) {
    const s = t.nextElementSibling;
    e ? s.matches(e) && i.push(s) : i.push(s), t = s;
  }
  return i;
}
function K(t, e) {
  return k().getComputedStyle(t, null).getPropertyValue(e);
}
function _e(t) {
  let e = t, i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (i += 1);
    return i;
  }
}
function Ct(t, e) {
  const i = [];
  let s = t.parentElement;
  for (; s; )
    i.push(s), s = s.parentElement;
  return i;
}
function Ae(t, e, i) {
  const s = k();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function Ne(t, e) {
  e === void 0 && (e = ""), typeof trustedTypes < "u" ? t.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (i) => i
  }).createHTML(e) : t.innerHTML = e;
}
let he;
function Pt() {
  const t = k(), e = ie();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Ue() {
  return he || (he = Pt()), he;
}
let ge;
function Mt(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const i = Ue(), s = k(), n = s.navigator.platform, r = e || s.navigator.userAgent, l = {
    ios: !1,
    android: !1
  }, a = s.screen.width, o = s.screen.height, d = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let c = r.match(/(iPad).*OS\s([\d_]+)/);
  const u = r.match(/(iPod)(.*OS\s([\d_]+))?/), f = !c && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), h = n === "Win32";
  let p = n === "MacIntel";
  const T = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !c && p && i.touch && T.indexOf(`${a}x${o}`) >= 0 && (c = r.match(/(Version)\/([\d.]+)/), c || (c = [0, 1, "13_0_0"]), p = !1), d && !h && (l.os = "android", l.android = !0), (c || f || u) && (l.os = "ios", l.ios = !0), l;
}
function Ke(t) {
  return t === void 0 && (t = {}), ge || (ge = Mt(t)), ge;
}
let ve;
function It() {
  const t = k(), e = Ke();
  let i = !1;
  function s() {
    const a = t.navigator.userAgent.toLowerCase();
    return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0;
  }
  if (s()) {
    const a = String(t.navigator.userAgent);
    if (a.includes("Version/")) {
      const [o, d] = a.split("Version/")[1].split(" ")[0].split(".").map((c) => Number(c));
      i = o < 16 || o === 16 && d < 2;
    }
  }
  const n = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), r = s(), l = r || n && e.ios;
  return {
    isSafari: i || r,
    needPerspectiveFix: i,
    need3dFix: l,
    isWebView: n
  };
}
function Qe() {
  return ve || (ve = It()), ve;
}
function Lt(t) {
  let {
    swiper: e,
    on: i,
    emit: s
  } = t;
  const n = k();
  let r = null, l = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (s("beforeResize"), s("resize"));
  }, o = () => {
    !e || e.destroyed || !e.initialized || (r = new ResizeObserver((u) => {
      l = n.requestAnimationFrame(() => {
        const {
          width: f,
          height: h
        } = e;
        let p = f, T = h;
        u.forEach((C) => {
          let {
            contentBoxSize: m,
            contentRect: g,
            target: v
          } = C;
          v && v !== e.el || (p = g ? g.width : (m[0] || m).inlineSize, T = g ? g.height : (m[0] || m).blockSize);
        }), (p !== f || T !== h) && a();
      });
    }), r.observe(e.el));
  }, d = () => {
    l && n.cancelAnimationFrame(l), r && r.unobserve && e.el && (r.unobserve(e.el), r = null);
  }, c = () => {
    !e || e.destroyed || !e.initialized || s("orientationchange");
  };
  i("init", () => {
    if (e.params.resizeObserver && typeof n.ResizeObserver < "u") {
      o();
      return;
    }
    n.addEventListener("resize", a), n.addEventListener("orientationchange", c);
  }), i("destroy", () => {
    d(), n.removeEventListener("resize", a), n.removeEventListener("orientationchange", c);
  });
}
function Ot(t) {
  let {
    swiper: e,
    extendParams: i,
    on: s,
    emit: n
  } = t;
  const r = [], l = k(), a = function(c, u) {
    u === void 0 && (u = {});
    const f = l.MutationObserver || l.WebkitMutationObserver, h = new f((p) => {
      if (e.__preventObserver__) return;
      if (p.length === 1) {
        n("observerUpdate", p[0]);
        return;
      }
      const T = function() {
        n("observerUpdate", p[0]);
      };
      l.requestAnimationFrame ? l.requestAnimationFrame(T) : l.setTimeout(T, 0);
    });
    h.observe(c, {
      attributes: typeof u.attributes > "u" ? !0 : u.attributes,
      childList: e.isElement || (typeof u.childList > "u" ? !0 : u).childList,
      characterData: typeof u.characterData > "u" ? !0 : u.characterData
    }), r.push(h);
  }, o = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const c = Ct(e.hostEl);
        for (let u = 0; u < c.length; u += 1)
          a(c[u]);
      }
      a(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), a(e.wrapperEl, {
        attributes: !1
      });
    }
  }, d = () => {
    r.forEach((c) => {
      c.disconnect();
    }), r.splice(0, r.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", o), s("destroy", d);
}
var zt = {
  on(t, e, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    const n = i ? "unshift" : "push";
    return t.split(" ").forEach((r) => {
      s.eventsListeners[r] || (s.eventsListeners[r] = []), s.eventsListeners[r][n](e);
    }), s;
  },
  once(t, e, i) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    function n() {
      s.off(t, n), n.__emitterProxy && delete n.__emitterProxy;
      for (var r = arguments.length, l = new Array(r), a = 0; a < r; a++)
        l[a] = arguments[a];
      e.apply(s, l);
    }
    return n.__emitterProxy = e, s.on(t, n, i);
  },
  onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const s = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[s](t), i;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  },
  off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach((s) => {
      typeof e > "u" ? i.eventsListeners[s] = [] : i.eventsListeners[s] && i.eventsListeners[s].forEach((n, r) => {
        (n === e || n.__emitterProxy && n.__emitterProxy === e) && i.eventsListeners[s].splice(r, 1);
      });
    }), i;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, i, s;
    for (var n = arguments.length, r = new Array(n), l = 0; l < n; l++)
      r[l] = arguments[l];
    return typeof r[0] == "string" || Array.isArray(r[0]) ? (e = r[0], i = r.slice(1, r.length), s = t) : (e = r[0].events, i = r[0].data, s = r[0].context || t), i.unshift(s), (Array.isArray(e) ? e : e.split(" ")).forEach((o) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((d) => {
        d.apply(s, [o, ...i]);
      }), t.eventsListeners && t.eventsListeners[o] && t.eventsListeners[o].forEach((d) => {
        d.apply(s, i);
      });
    }), t;
  }
};
function _t() {
  const t = this;
  let e, i;
  const s = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = s.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? i = t.params.height : i = s.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(K(s, "padding-left") || 0, 10) - parseInt(K(s, "padding-right") || 0, 10), i = i - parseInt(K(s, "padding-top") || 0, 10) - parseInt(K(s, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
    width: e,
    height: i,
    size: t.isHorizontal() ? e : i
  }));
}
function At() {
  const t = this;
  function e(S, y) {
    return parseFloat(S.getPropertyValue(t.getDirectionLabel(y)) || 0);
  }
  const i = t.params, {
    wrapperEl: s,
    slidesEl: n,
    size: r,
    rtlTranslate: l,
    wrongRTL: a
  } = t, o = t.virtual && i.virtual.enabled, d = o ? t.virtual.slides.length : t.slides.length, c = Y(n, `.${t.params.slideClass}, swiper-slide`), u = o ? t.virtual.slides.length : c.length;
  let f = [];
  const h = [], p = [];
  let T = i.slidesOffsetBefore;
  typeof T == "function" && (T = i.slidesOffsetBefore.call(t));
  let C = i.slidesOffsetAfter;
  typeof C == "function" && (C = i.slidesOffsetAfter.call(t));
  const m = t.snapGrid.length, g = t.slidesGrid.length;
  let v = i.spaceBetween, E = -T, x = 0, I = 0;
  if (typeof r > "u")
    return;
  typeof v == "string" && v.indexOf("%") >= 0 ? v = parseFloat(v.replace("%", "")) / 100 * r : typeof v == "string" && (v = parseFloat(v)), t.virtualSize = -v, c.forEach((S) => {
    l ? S.style.marginLeft = "" : S.style.marginRight = "", S.style.marginBottom = "", S.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (le(s, "--swiper-centered-offset-before", ""), le(s, "--swiper-centered-offset-after", ""));
  const M = i.grid && i.grid.rows > 1 && t.grid;
  M ? t.grid.initSlides(c) : t.grid && t.grid.unsetSlides();
  let b;
  const w = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((S) => typeof i.breakpoints[S].slidesPerView < "u").length > 0;
  for (let S = 0; S < u; S += 1) {
    b = 0;
    let y;
    if (c[S] && (y = c[S]), M && t.grid.updateSlide(S, y, c), !(c[S] && K(y, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        w && (c[S].style[t.getDirectionLabel("width")] = "");
        const P = getComputedStyle(y), z = y.style.transform, $ = y.style.webkitTransform;
        if (z && (y.style.transform = "none"), $ && (y.style.webkitTransform = "none"), i.roundLengths)
          b = t.isHorizontal() ? Ae(y, "width") : Ae(y, "height");
        else {
          const F = e(P, "width"), L = e(P, "padding-left"), A = e(P, "padding-right"), G = e(P, "margin-left"), _ = e(P, "margin-right"), B = P.getPropertyValue("box-sizing");
          if (B && B === "border-box")
            b = F + G + _;
          else {
            const {
              clientWidth: J,
              offsetWidth: O
            } = y;
            b = F + L + A + G + _ + (O - J);
          }
        }
        z && (y.style.transform = z), $ && (y.style.webkitTransform = $), i.roundLengths && (b = Math.floor(b));
      } else
        b = (r - (i.slidesPerView - 1) * v) / i.slidesPerView, i.roundLengths && (b = Math.floor(b)), c[S] && (c[S].style[t.getDirectionLabel("width")] = `${b}px`);
      c[S] && (c[S].swiperSlideSize = b), p.push(b), i.centeredSlides ? (E = E + b / 2 + x / 2 + v, x === 0 && S !== 0 && (E = E - r / 2 - v), S === 0 && (E = E - r / 2 - v), Math.abs(E) < 1 / 1e3 && (E = 0), i.roundLengths && (E = Math.floor(E)), I % i.slidesPerGroup === 0 && f.push(E), h.push(E)) : (i.roundLengths && (E = Math.floor(E)), (I - Math.min(t.params.slidesPerGroupSkip, I)) % t.params.slidesPerGroup === 0 && f.push(E), h.push(E), E = E + b + v), t.virtualSize += b + v, x = b, I += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, r) + C, l && a && (i.effect === "slide" || i.effect === "coverflow") && (s.style.width = `${t.virtualSize + v}px`), i.setWrapperSize && (s.style[t.getDirectionLabel("width")] = `${t.virtualSize + v}px`), M && t.grid.updateWrapperSize(b, f), !i.centeredSlides) {
    const S = [];
    for (let y = 0; y < f.length; y += 1) {
      let P = f[y];
      i.roundLengths && (P = Math.floor(P)), f[y] <= t.virtualSize - r && S.push(P);
    }
    f = S, Math.floor(t.virtualSize - r) - Math.floor(f[f.length - 1]) > 1 && f.push(t.virtualSize - r);
  }
  if (o && i.loop) {
    const S = p[0] + v;
    if (i.slidesPerGroup > 1) {
      const y = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup), P = S * i.slidesPerGroup;
      for (let z = 0; z < y; z += 1)
        f.push(f[f.length - 1] + P);
    }
    for (let y = 0; y < t.virtual.slidesBefore + t.virtual.slidesAfter; y += 1)
      i.slidesPerGroup === 1 && f.push(f[f.length - 1] + S), h.push(h[h.length - 1] + S), t.virtualSize += S;
  }
  if (f.length === 0 && (f = [0]), v !== 0) {
    const S = t.isHorizontal() && l ? "marginLeft" : t.getDirectionLabel("marginRight");
    c.filter((y, P) => !i.cssMode || i.loop ? !0 : P !== c.length - 1).forEach((y) => {
      y.style[S] = `${v}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let S = 0;
    p.forEach((P) => {
      S += P + (v || 0);
    }), S -= v;
    const y = S > r ? S - r : 0;
    f = f.map((P) => P <= 0 ? -T : P > y ? y + C : P);
  }
  if (i.centerInsufficientSlides) {
    let S = 0;
    p.forEach((P) => {
      S += P + (v || 0);
    }), S -= v;
    const y = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (S + y < r) {
      const P = (r - S - y) / 2;
      f.forEach((z, $) => {
        f[$] = z - P;
      }), h.forEach((z, $) => {
        h[$] = z + P;
      });
    }
  }
  if (Object.assign(t, {
    slides: c,
    snapGrid: f,
    slidesGrid: h,
    slidesSizesGrid: p
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    le(s, "--swiper-centered-offset-before", `${-f[0]}px`), le(s, "--swiper-centered-offset-after", `${t.size / 2 - p[p.length - 1] / 2}px`);
    const S = -t.snapGrid[0], y = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((P) => P + S), t.slidesGrid = t.slidesGrid.map((P) => P + y);
  }
  if (u !== d && t.emit("slidesLengthChange"), f.length !== m && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), h.length !== g && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !o && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const S = `${i.containerModifierClass}backface-hidden`, y = t.el.classList.contains(S);
    u <= i.maxBackfaceHiddenSlides ? y || t.el.classList.add(S) : y && t.el.classList.remove(S);
  }
}
function Nt(t) {
  const e = this, i = [], s = e.virtual && e.params.virtual.enabled;
  let n = 0, r;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const l = (a) => s ? e.slides[e.getSlideIndexByData(a)] : e.slides[a];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((a) => {
        i.push(a);
      });
    else
      for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
        const a = e.activeIndex + r;
        if (a > e.slides.length && !s) break;
        i.push(l(a));
      }
  else
    i.push(l(e.activeIndex));
  for (r = 0; r < i.length; r += 1)
    if (typeof i[r] < "u") {
      const a = i[r].offsetHeight;
      n = a > n ? a : n;
    }
  (n || n === 0) && (e.wrapperEl.style.height = `${n}px`);
}
function Gt() {
  const t = this, e = t.slides, i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let s = 0; s < e.length; s += 1)
    e[s].swiperSlideOffset = (t.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) - i - t.cssOverflowAdjustment();
}
const Ge = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function Dt(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, i = e.params, {
    slides: s,
    rtlTranslate: n,
    snapGrid: r
  } = e;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let l = -t;
  n && (l = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let a = i.spaceBetween;
  typeof a == "string" && a.indexOf("%") >= 0 ? a = parseFloat(a.replace("%", "")) / 100 * e.size : typeof a == "string" && (a = parseFloat(a));
  for (let o = 0; o < s.length; o += 1) {
    const d = s[o];
    let c = d.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (c -= s[0].swiperSlideOffset);
    const u = (l + (i.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + a), f = (l - r[0] + (i.centeredSlides ? e.minTranslate() : 0) - c) / (d.swiperSlideSize + a), h = -(l - c), p = h + e.slidesSizesGrid[o], T = h >= 0 && h <= e.size - e.slidesSizesGrid[o], C = h >= 0 && h < e.size - 1 || p > 1 && p <= e.size || h <= 0 && p >= e.size;
    C && (e.visibleSlides.push(d), e.visibleSlidesIndexes.push(o)), Ge(d, C, i.slideVisibleClass), Ge(d, T, i.slideFullyVisibleClass), d.progress = n ? -u : u, d.originalProgress = n ? -f : f;
  }
}
function Vt(t) {
  const e = this;
  if (typeof t > "u") {
    const c = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * c || 0;
  }
  const i = e.params, s = e.maxTranslate() - e.minTranslate();
  let {
    progress: n,
    isBeginning: r,
    isEnd: l,
    progressLoop: a
  } = e;
  const o = r, d = l;
  if (s === 0)
    n = 0, r = !0, l = !0;
  else {
    n = (t - e.minTranslate()) / s;
    const c = Math.abs(t - e.minTranslate()) < 1, u = Math.abs(t - e.maxTranslate()) < 1;
    r = c || n <= 0, l = u || n >= 1, c && (n = 0), u && (n = 1);
  }
  if (i.loop) {
    const c = e.getSlideIndexByData(0), u = e.getSlideIndexByData(e.slides.length - 1), f = e.slidesGrid[c], h = e.slidesGrid[u], p = e.slidesGrid[e.slidesGrid.length - 1], T = Math.abs(t);
    T >= f ? a = (T - f) / p : a = (T + p - h) / p, a > 1 && (a -= 1);
  }
  Object.assign(e, {
    progress: n,
    progressLoop: a,
    isBeginning: r,
    isEnd: l
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), r && !o && e.emit("reachBeginning toEdge"), l && !d && e.emit("reachEnd toEdge"), (o && !r || d && !l) && e.emit("fromEdge"), e.emit("progress", n);
}
const we = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function $t() {
  const t = this, {
    slides: e,
    params: i,
    slidesEl: s,
    activeIndex: n
  } = t, r = t.virtual && i.virtual.enabled, l = t.grid && i.grid && i.grid.rows > 1, a = (u) => Y(s, `.${i.slideClass}${u}, swiper-slide${u}`)[0];
  let o, d, c;
  if (r)
    if (i.loop) {
      let u = n - t.virtual.slidesBefore;
      u < 0 && (u = t.virtual.slides.length + u), u >= t.virtual.slides.length && (u -= t.virtual.slides.length), o = a(`[data-swiper-slide-index="${u}"]`);
    } else
      o = a(`[data-swiper-slide-index="${n}"]`);
  else
    l ? (o = e.find((u) => u.column === n), c = e.find((u) => u.column === n + 1), d = e.find((u) => u.column === n - 1)) : o = e[n];
  o && (l || (c = Et(o, `.${i.slideClass}, swiper-slide`)[0], i.loop && !c && (c = e[0]), d = yt(o, `.${i.slideClass}, swiper-slide`)[0], i.loop && !d === 0 && (d = e[e.length - 1]))), e.forEach((u) => {
    we(u, u === o, i.slideActiveClass), we(u, u === c, i.slideNextClass), we(u, u === d, i.slidePrevClass);
  }), t.emitSlidesClasses();
}
const oe = (t, e) => {
  if (!t || t.destroyed || !t.params) return;
  const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, s = e.closest(i());
  if (s) {
    let n = s.querySelector(`.${t.params.lazyPreloaderClass}`);
    !n && t.isElement && (s.shadowRoot ? n = s.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      s.shadowRoot && (n = s.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), n && n.remove());
    })), n && n.remove();
  }
}, Se = (t, e) => {
  if (!t.slides[e]) return;
  const i = t.slides[e].querySelector('[loading="lazy"]');
  i && i.removeAttribute("loading");
}, ye = (t) => {
  if (!t || t.destroyed || !t.params) return;
  let e = t.params.lazyPreloadPrevNext;
  const i = t.slides.length;
  if (!i || !e || e < 0) return;
  e = Math.min(e, i);
  const s = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), n = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const l = n, a = [l - e];
    a.push(...Array.from({
      length: e
    }).map((o, d) => l + s + d)), t.slides.forEach((o, d) => {
      a.includes(o.column) && Se(t, d);
    });
    return;
  }
  const r = n + s - 1;
  if (t.params.rewind || t.params.loop)
    for (let l = n - e; l <= r + e; l += 1) {
      const a = (l % i + i) % i;
      (a < n || a > r) && Se(t, a);
    }
  else
    for (let l = Math.max(n - e, 0); l <= Math.min(r + e, i - 1); l += 1)
      l !== n && (l > r || l < n) && Se(t, l);
};
function Bt(t) {
  const {
    slidesGrid: e,
    params: i
  } = t, s = t.rtlTranslate ? t.translate : -t.translate;
  let n;
  for (let r = 0; r < e.length; r += 1)
    typeof e[r + 1] < "u" ? s >= e[r] && s < e[r + 1] - (e[r + 1] - e[r]) / 2 ? n = r : s >= e[r] && s < e[r + 1] && (n = r + 1) : s >= e[r] && (n = r);
  return i.normalizeSlideIndex && (n < 0 || typeof n > "u") && (n = 0), n;
}
function Ft(t) {
  const e = this, i = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: s,
    params: n,
    activeIndex: r,
    realIndex: l,
    snapIndex: a
  } = e;
  let o = t, d;
  const c = (h) => {
    let p = h - e.virtual.slidesBefore;
    return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
  };
  if (typeof o > "u" && (o = Bt(e)), s.indexOf(i) >= 0)
    d = s.indexOf(i);
  else {
    const h = Math.min(n.slidesPerGroupSkip, o);
    d = h + Math.floor((o - h) / n.slidesPerGroup);
  }
  if (d >= s.length && (d = s.length - 1), o === r && !e.params.loop) {
    d !== a && (e.snapIndex = d, e.emit("snapIndexChange"));
    return;
  }
  if (o === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = c(o);
    return;
  }
  const u = e.grid && n.grid && n.grid.rows > 1;
  let f;
  if (e.virtual && n.virtual.enabled && n.loop)
    f = c(o);
  else if (u) {
    const h = e.slides.find((T) => T.column === o);
    let p = parseInt(h.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(e.slides.indexOf(h), 0)), f = Math.floor(p / n.grid.rows);
  } else if (e.slides[o]) {
    const h = e.slides[o].getAttribute("data-swiper-slide-index");
    h ? f = parseInt(h, 10) : f = o;
  } else
    f = o;
  Object.assign(e, {
    previousSnapIndex: a,
    snapIndex: d,
    previousRealIndex: l,
    realIndex: f,
    previousIndex: r,
    activeIndex: o
  }), e.initialized && ye(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (l !== f && e.emit("realIndexChange"), e.emit("slideChange"));
}
function Rt(t, e) {
  const i = this, s = i.params;
  let n = t.closest(`.${s.slideClass}, swiper-slide`);
  !n && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((a) => {
    !n && a.matches && a.matches(`.${s.slideClass}, swiper-slide`) && (n = a);
  });
  let r = !1, l;
  if (n) {
    for (let a = 0; a < i.slides.length; a += 1)
      if (i.slides[a] === n) {
        r = !0, l = a;
        break;
      }
  }
  if (n && r)
    i.clickedSlide = n, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = l;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var kt = {
  updateSize: _t,
  updateSlides: At,
  updateAutoHeight: Nt,
  updateSlidesOffset: Gt,
  updateSlidesProgress: Dt,
  updateProgress: Vt,
  updateSlidesClasses: $t,
  updateActiveIndex: Ft,
  updateClickedSlide: Rt
};
function Ht(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: i,
    rtlTranslate: s,
    translate: n,
    wrapperEl: r
  } = e;
  if (i.virtualTranslate)
    return s ? -n : n;
  if (i.cssMode)
    return n;
  let l = St(r, t);
  return l += e.cssOverflowAdjustment(), s && (l = -l), l || 0;
}
function jt(t, e) {
  const i = this, {
    rtlTranslate: s,
    params: n,
    wrapperEl: r,
    progress: l
  } = i;
  let a = 0, o = 0;
  const d = 0;
  i.isHorizontal() ? a = s ? -t : t : o = t, n.roundLengths && (a = Math.floor(a), o = Math.floor(o)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? a : o, n.cssMode ? r[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -a : -o : n.virtualTranslate || (i.isHorizontal() ? a -= i.cssOverflowAdjustment() : o -= i.cssOverflowAdjustment(), r.style.transform = `translate3d(${a}px, ${o}px, ${d}px)`);
  let c;
  const u = i.maxTranslate() - i.minTranslate();
  u === 0 ? c = 0 : c = (t - i.minTranslate()) / u, c !== l && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
}
function Wt() {
  return -this.snapGrid[0];
}
function Xt() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function qt(t, e, i, s, n) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), i === void 0 && (i = !0), s === void 0 && (s = !0);
  const r = this, {
    params: l,
    wrapperEl: a
  } = r;
  if (r.animating && l.preventInteractionOnTransition)
    return !1;
  const o = r.minTranslate(), d = r.maxTranslate();
  let c;
  if (s && t > o ? c = o : s && t < d ? c = d : c = t, r.updateProgress(c), l.cssMode) {
    const u = r.isHorizontal();
    if (e === 0)
      a[u ? "scrollLeft" : "scrollTop"] = -c;
    else {
      if (!r.support.smoothScroll)
        return Ye({
          swiper: r,
          targetPosition: -c,
          side: u ? "left" : "top"
        }), !0;
      a.scrollTo({
        [u ? "left" : "top"]: -c,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (r.setTransition(0), r.setTranslate(c), i && (r.emit("beforeTransitionStart", e, n), r.emit("transitionEnd"))) : (r.setTransition(e), r.setTranslate(c), i && (r.emit("beforeTransitionStart", e, n), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(f) {
    !r || r.destroyed || f.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, i && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var Yt = {
  getTranslate: Ht,
  setTranslate: jt,
  minTranslate: Wt,
  maxTranslate: Xt,
  translateTo: qt
};
function Ut(t, e) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
}
function Ze(t) {
  let {
    swiper: e,
    runCallbacks: i,
    direction: s,
    step: n
  } = t;
  const {
    activeIndex: r,
    previousIndex: l
  } = e;
  let a = s;
  a || (r > l ? a = "next" : r < l ? a = "prev" : a = "reset"), e.emit(`transition${n}`), i && a === "reset" ? e.emit(`slideResetTransition${n}`) : i && r !== l && (e.emit(`slideChangeTransition${n}`), a === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`));
}
function Kt(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: s
  } = i;
  s.cssMode || (s.autoHeight && i.updateAutoHeight(), Ze({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function Qt(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: s
  } = i;
  i.animating = !1, !s.cssMode && (i.setTransition(0), Ze({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var Zt = {
  setTransition: Ut,
  transitionStart: Kt,
  transitionEnd: Qt
};
function Jt(t, e, i, s, n) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const r = this;
  let l = t;
  l < 0 && (l = 0);
  const {
    params: a,
    snapGrid: o,
    slidesGrid: d,
    previousIndex: c,
    activeIndex: u,
    rtlTranslate: f,
    wrapperEl: h,
    enabled: p
  } = r;
  if (!p && !s && !n || r.destroyed || r.animating && a.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = r.params.speed);
  const T = Math.min(r.params.slidesPerGroupSkip, l);
  let C = T + Math.floor((l - T) / r.params.slidesPerGroup);
  C >= o.length && (C = o.length - 1);
  const m = -o[C];
  if (a.normalizeSlideIndex)
    for (let M = 0; M < d.length; M += 1) {
      const b = -Math.floor(m * 100), w = Math.floor(d[M] * 100), S = Math.floor(d[M + 1] * 100);
      typeof d[M + 1] < "u" ? b >= w && b < S - (S - w) / 2 ? l = M : b >= w && b < S && (l = M + 1) : b >= w && (l = M);
    }
  if (r.initialized && l !== u && (!r.allowSlideNext && (f ? m > r.translate && m > r.minTranslate() : m < r.translate && m < r.minTranslate()) || !r.allowSlidePrev && m > r.translate && m > r.maxTranslate() && (u || 0) !== l))
    return !1;
  l !== (c || 0) && i && r.emit("beforeSlideChangeStart"), r.updateProgress(m);
  let g;
  l > u ? g = "next" : l < u ? g = "prev" : g = "reset";
  const v = r.virtual && r.params.virtual.enabled;
  if (!(v && n) && (f && -m === r.translate || !f && m === r.translate))
    return r.updateActiveIndex(l), a.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), a.effect !== "slide" && r.setTranslate(m), g !== "reset" && (r.transitionStart(i, g), r.transitionEnd(i, g)), !1;
  if (a.cssMode) {
    const M = r.isHorizontal(), b = f ? m : -m;
    if (e === 0)
      v && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), v && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        h[M ? "scrollLeft" : "scrollTop"] = b;
      })) : h[M ? "scrollLeft" : "scrollTop"] = b, v && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return Ye({
          swiper: r,
          targetPosition: b,
          side: M ? "left" : "top"
        }), !0;
      h.scrollTo({
        [M ? "left" : "top"]: b,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const I = Qe().isSafari;
  return v && !n && I && r.isElement && r.virtual.update(!1, !1, l), r.setTransition(e), r.setTranslate(m), r.updateActiveIndex(l), r.updateSlidesClasses(), r.emit("beforeTransitionStart", e, s), r.transitionStart(i, g), e === 0 ? r.transitionEnd(i, g) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(b) {
    !r || r.destroyed || b.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(i, g));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function ei(t, e, i, s) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const n = this;
  if (n.destroyed) return;
  typeof e > "u" && (e = n.params.speed);
  const r = n.grid && n.params.grid && n.params.grid.rows > 1;
  let l = t;
  if (n.params.loop)
    if (n.virtual && n.params.virtual.enabled)
      l = l + n.virtual.slidesBefore;
    else {
      let a;
      if (r) {
        const f = l * n.params.grid.rows;
        a = n.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === f).column;
      } else
        a = n.getSlideIndexByData(l);
      const o = r ? Math.ceil(n.slides.length / n.params.grid.rows) : n.slides.length, {
        centeredSlides: d
      } = n.params;
      let c = n.params.slidesPerView;
      c === "auto" ? c = n.slidesPerViewDynamic() : (c = Math.ceil(parseFloat(n.params.slidesPerView, 10)), d && c % 2 === 0 && (c = c + 1));
      let u = o - a < c;
      if (d && (u = u || a < Math.ceil(c / 2)), s && d && n.params.slidesPerView !== "auto" && !r && (u = !1), u) {
        const f = d ? a < n.activeIndex ? "prev" : "next" : a - n.activeIndex - 1 < n.params.slidesPerView ? "next" : "prev";
        n.loopFix({
          direction: f,
          slideTo: !0,
          activeSlideIndex: f === "next" ? a + 1 : a - o + 1,
          slideRealIndex: f === "next" ? n.realIndex : void 0
        });
      }
      if (r) {
        const f = l * n.params.grid.rows;
        l = n.slides.find((h) => h.getAttribute("data-swiper-slide-index") * 1 === f).column;
      } else
        l = n.getSlideIndexByData(l);
    }
  return requestAnimationFrame(() => {
    n.slideTo(l, e, i, s);
  }), n;
}
function ti(t, e, i) {
  e === void 0 && (e = !0);
  const s = this, {
    enabled: n,
    params: r,
    animating: l
  } = s;
  if (!n || s.destroyed) return s;
  typeof t > "u" && (t = s.params.speed);
  let a = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (a = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const o = s.activeIndex < r.slidesPerGroupSkip ? 1 : a, d = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (l && !d && r.loopPreventsSliding) return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        s.slideTo(s.activeIndex + o, t, e, i);
      }), !0;
  }
  return r.rewind && s.isEnd ? s.slideTo(0, t, e, i) : s.slideTo(s.activeIndex + o, t, e, i);
}
function ii(t, e, i) {
  e === void 0 && (e = !0);
  const s = this, {
    params: n,
    snapGrid: r,
    slidesGrid: l,
    rtlTranslate: a,
    enabled: o,
    animating: d
  } = s;
  if (!o || s.destroyed) return s;
  typeof t > "u" && (t = s.params.speed);
  const c = s.virtual && n.virtual.enabled;
  if (n.loop) {
    if (d && !c && n.loopPreventsSliding) return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const u = a ? s.translate : -s.translate;
  function f(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const h = f(u), p = r.map((g) => f(g)), T = n.freeMode && n.freeMode.enabled;
  let C = r[p.indexOf(h) - 1];
  if (typeof C > "u" && (n.cssMode || T)) {
    let g;
    r.forEach((v, E) => {
      h >= v && (g = E);
    }), typeof g < "u" && (C = T ? r[g] : r[g > 0 ? g - 1 : g]);
  }
  let m = 0;
  if (typeof C < "u" && (m = l.indexOf(C), m < 0 && (m = s.activeIndex - 1), n.slidesPerView === "auto" && n.slidesPerGroup === 1 && n.slidesPerGroupAuto && (m = m - s.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), n.rewind && s.isBeginning) {
    const g = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(g, t, e, i);
  } else if (n.loop && s.activeIndex === 0 && n.cssMode)
    return requestAnimationFrame(() => {
      s.slideTo(m, t, e, i);
    }), !0;
  return s.slideTo(m, t, e, i);
}
function si(t, e, i) {
  e === void 0 && (e = !0);
  const s = this;
  if (!s.destroyed)
    return typeof t > "u" && (t = s.params.speed), s.slideTo(s.activeIndex, t, e, i);
}
function ri(t, e, i, s) {
  e === void 0 && (e = !0), s === void 0 && (s = 0.5);
  const n = this;
  if (n.destroyed) return;
  typeof t > "u" && (t = n.params.speed);
  let r = n.activeIndex;
  const l = Math.min(n.params.slidesPerGroupSkip, r), a = l + Math.floor((r - l) / n.params.slidesPerGroup), o = n.rtlTranslate ? n.translate : -n.translate;
  if (o >= n.snapGrid[a]) {
    const d = n.snapGrid[a], c = n.snapGrid[a + 1];
    o - d > (c - d) * s && (r += n.params.slidesPerGroup);
  } else {
    const d = n.snapGrid[a - 1], c = n.snapGrid[a];
    o - d <= (c - d) * s && (r -= n.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, n.slidesGrid.length - 1), n.slideTo(r, t, e, i);
}
function ni() {
  const t = this;
  if (t.destroyed) return;
  const {
    params: e,
    slidesEl: i
  } = t, s = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let n = t.getSlideIndexWhenGrid(t.clickedIndex), r;
  const l = t.isElement ? "swiper-slide" : `.${e.slideClass}`, a = t.grid && t.params.grid && t.params.grid.rows > 1;
  if (e.loop) {
    if (t.animating) return;
    r = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? t.slideToLoop(r) : n > (a ? (t.slides.length - s) / 2 - (t.params.grid.rows - 1) : t.slides.length - s) ? (t.loopFix(), n = t.getSlideIndex(Y(i, `${l}[data-swiper-slide-index="${r}"]`)[0]), qe(() => {
      t.slideTo(n);
    })) : t.slideTo(n);
  } else
    t.slideTo(n);
}
var ai = {
  slideTo: Jt,
  slideToLoop: ei,
  slideNext: ti,
  slidePrev: ii,
  slideReset: si,
  slideToClosest: ri,
  slideToClickedSlide: ni
};
function li(t, e) {
  const i = this, {
    params: s,
    slidesEl: n
  } = i;
  if (!s.loop || i.virtual && i.params.virtual.enabled) return;
  const r = () => {
    Y(n, `.${s.slideClass}, swiper-slide`).forEach((h, p) => {
      h.setAttribute("data-swiper-slide-index", p);
    });
  }, l = () => {
    const f = Y(n, `.${s.slideBlankClass}`);
    f.forEach((h) => {
      h.remove();
    }), f.length > 0 && (i.recalcSlides(), i.updateSlides());
  }, a = i.grid && s.grid && s.grid.rows > 1;
  s.loopAddBlankSlides && (s.slidesPerGroup > 1 || a) && l();
  const o = s.slidesPerGroup * (a ? s.grid.rows : 1), d = i.slides.length % o !== 0, c = a && i.slides.length % s.grid.rows !== 0, u = (f) => {
    for (let h = 0; h < f; h += 1) {
      const p = i.isElement ? xe("swiper-slide", [s.slideBlankClass]) : xe("div", [s.slideClass, s.slideBlankClass]);
      i.slidesEl.append(p);
    }
  };
  if (d) {
    if (s.loopAddBlankSlides) {
      const f = o - i.slides.length % o;
      u(f), i.recalcSlides(), i.updateSlides();
    } else
      ce("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (c) {
    if (s.loopAddBlankSlides) {
      const f = s.grid.rows - i.slides.length % s.grid.rows;
      u(f), i.recalcSlides(), i.updateSlides();
    } else
      ce("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  i.loopFix({
    slideRealIndex: t,
    direction: s.centeredSlides ? void 0 : "next",
    initial: e
  });
}
function oi(t) {
  let {
    slideRealIndex: e,
    slideTo: i = !0,
    direction: s,
    setTranslate: n,
    activeSlideIndex: r,
    initial: l,
    byController: a,
    byMousewheel: o
  } = t === void 0 ? {} : t;
  const d = this;
  if (!d.params.loop) return;
  d.emit("beforeLoopFix");
  const {
    slides: c,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: h,
    params: p
  } = d, {
    centeredSlides: T,
    initialSlide: C
  } = p;
  if (d.allowSlidePrev = !0, d.allowSlideNext = !0, d.virtual && p.virtual.enabled) {
    i && (!p.centeredSlides && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, !1, !0) : p.centeredSlides && d.snapIndex < p.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, !1, !0)), d.allowSlidePrev = u, d.allowSlideNext = f, d.emit("loopFix");
    return;
  }
  let m = p.slidesPerView;
  m === "auto" ? m = d.slidesPerViewDynamic() : (m = Math.ceil(parseFloat(p.slidesPerView, 10)), T && m % 2 === 0 && (m = m + 1));
  const g = p.slidesPerGroupAuto ? m : p.slidesPerGroup;
  let v = T ? Math.max(g, Math.ceil(m / 2)) : g;
  v % g !== 0 && (v += g - v % g), v += p.loopAdditionalSlides, d.loopedSlides = v;
  const E = d.grid && p.grid && p.grid.rows > 1;
  c.length < m + v || d.params.effect === "cards" && c.length < m + v * 2 ? ce("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : E && p.grid.fill === "row" && ce("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const x = [], I = [], M = E ? Math.ceil(c.length / p.grid.rows) : c.length, b = l && M - C < m && !T;
  let w = b ? C : d.activeIndex;
  typeof r > "u" ? r = d.getSlideIndex(c.find((L) => L.classList.contains(p.slideActiveClass))) : w = r;
  const S = s === "next" || !s, y = s === "prev" || !s;
  let P = 0, z = 0;
  const F = (E ? c[r].column : r) + (T && typeof n > "u" ? -m / 2 + 0.5 : 0);
  if (F < v) {
    P = Math.max(v - F, g);
    for (let L = 0; L < v - F; L += 1) {
      const A = L - Math.floor(L / M) * M;
      if (E) {
        const G = M - A - 1;
        for (let _ = c.length - 1; _ >= 0; _ -= 1)
          c[_].column === G && x.push(_);
      } else
        x.push(M - A - 1);
    }
  } else if (F + m > M - v) {
    z = Math.max(F - (M - v * 2), g), b && (z = Math.max(z, m - M + C + 1));
    for (let L = 0; L < z; L += 1) {
      const A = L - Math.floor(L / M) * M;
      E ? c.forEach((G, _) => {
        G.column === A && I.push(_);
      }) : I.push(A);
    }
  }
  if (d.__preventObserver__ = !0, requestAnimationFrame(() => {
    d.__preventObserver__ = !1;
  }), d.params.effect === "cards" && c.length < m + v * 2 && (I.includes(r) && I.splice(I.indexOf(r), 1), x.includes(r) && x.splice(x.indexOf(r), 1)), y && x.forEach((L) => {
    c[L].swiperLoopMoveDOM = !0, h.prepend(c[L]), c[L].swiperLoopMoveDOM = !1;
  }), S && I.forEach((L) => {
    c[L].swiperLoopMoveDOM = !0, h.append(c[L]), c[L].swiperLoopMoveDOM = !1;
  }), d.recalcSlides(), p.slidesPerView === "auto" ? d.updateSlides() : E && (x.length > 0 && y || I.length > 0 && S) && d.slides.forEach((L, A) => {
    d.grid.updateSlide(A, L, d.slides);
  }), p.watchSlidesProgress && d.updateSlidesOffset(), i) {
    if (x.length > 0 && y) {
      if (typeof e > "u") {
        const L = d.slidesGrid[w], G = d.slidesGrid[w + P] - L;
        o ? d.setTranslate(d.translate - G) : (d.slideTo(w + Math.ceil(P), 0, !1, !0), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - G, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - G));
      } else if (n) {
        const L = E ? x.length / p.grid.rows : x.length;
        d.slideTo(d.activeIndex + L, 0, !1, !0), d.touchEventsData.currentTranslate = d.translate;
      }
    } else if (I.length > 0 && S)
      if (typeof e > "u") {
        const L = d.slidesGrid[w], G = d.slidesGrid[w - z] - L;
        o ? d.setTranslate(d.translate - G) : (d.slideTo(w - z, 0, !1, !0), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - G, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - G));
      } else {
        const L = E ? I.length / p.grid.rows : I.length;
        d.slideTo(d.activeIndex - L, 0, !1, !0);
      }
  }
  if (d.allowSlidePrev = u, d.allowSlideNext = f, d.controller && d.controller.control && !a) {
    const L = {
      slideRealIndex: e,
      direction: s,
      setTranslate: n,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(d.controller.control) ? d.controller.control.forEach((A) => {
      !A.destroyed && A.params.loop && A.loopFix({
        ...L,
        slideTo: A.params.slidesPerView === p.slidesPerView ? i : !1
      });
    }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix({
      ...L,
      slideTo: d.controller.control.params.slidesPerView === p.slidesPerView ? i : !1
    });
  }
  d.emit("loopFix");
}
function di() {
  const t = this, {
    params: e,
    slidesEl: i
  } = t;
  if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const s = [];
  t.slides.forEach((n) => {
    const r = typeof n.swiperSlideIndex > "u" ? n.getAttribute("data-swiper-slide-index") * 1 : n.swiperSlideIndex;
    s[r] = n;
  }), t.slides.forEach((n) => {
    n.removeAttribute("data-swiper-slide-index");
  }), s.forEach((n) => {
    i.append(n);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var ci = {
  loopCreate: li,
  loopFix: oi,
  loopDestroy: di
};
function ui(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function fi() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var pi = {
  setGrabCursor: ui,
  unsetGrabCursor: fi
};
function mi(t, e) {
  e === void 0 && (e = this);
  function i(s) {
    if (!s || s === ie() || s === k()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const n = s.closest(t);
    return !n && !s.getRootNode ? null : n || i(s.getRootNode().host);
  }
  return i(e);
}
function De(t, e, i) {
  const s = k(), {
    params: n
  } = t, r = n.edgeSwipeDetection, l = n.edgeSwipeThreshold;
  return r && (i <= l || i >= s.innerWidth - l) ? r === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function hi(t) {
  const e = this, i = ie();
  let s = t;
  s.originalEvent && (s = s.originalEvent);
  const n = e.touchEventsData;
  if (s.type === "pointerdown") {
    if (n.pointerId !== null && n.pointerId !== s.pointerId)
      return;
    n.pointerId = s.pointerId;
  } else s.type === "touchstart" && s.targetTouches.length === 1 && (n.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    De(e, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: l,
    enabled: a
  } = e;
  if (!a || !r.simulateTouch && s.pointerType === "mouse" || e.animating && r.preventInteractionOnTransition)
    return;
  !e.animating && r.cssMode && r.loop && e.loopFix();
  let o = s.target;
  if (r.touchEventsTarget === "wrapper" && !xt(o, e.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || n.isTouched && n.isMoved) return;
  const d = !!r.noSwipingClass && r.noSwipingClass !== "", c = s.composedPath ? s.composedPath() : s.path;
  d && s.target && s.target.shadowRoot && c && (o = c[0]);
  const u = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, f = !!(s.target && s.target.shadowRoot);
  if (r.noSwiping && (f ? mi(u, o) : o.closest(u))) {
    e.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !o.closest(r.swipeHandler))
    return;
  l.currentX = s.pageX, l.currentY = s.pageY;
  const h = l.currentX, p = l.currentY;
  if (!De(e, s, h))
    return;
  Object.assign(n, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), l.startX = h, l.startY = p, n.touchStartTime = de(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, r.threshold > 0 && (n.allowThresholdMove = !1);
  let T = !0;
  o.matches(n.focusableElements) && (T = !1, o.nodeName === "SELECT" && (n.isTouched = !1)), i.activeElement && i.activeElement.matches(n.focusableElements) && i.activeElement !== o && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !o.matches(n.focusableElements)) && i.activeElement.blur();
  const C = T && e.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || C) && !o.isContentEditable && s.preventDefault(), r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", s);
}
function gi(t) {
  const e = ie(), i = this, s = i.touchEventsData, {
    params: n,
    touches: r,
    rtlTranslate: l,
    enabled: a
  } = i;
  if (!a || !n.simulateTouch && t.pointerType === "mouse") return;
  let o = t;
  if (o.originalEvent && (o = o.originalEvent), o.type === "pointermove" && (s.touchId !== null || o.pointerId !== s.pointerId))
    return;
  let d;
  if (o.type === "touchmove") {
    if (d = [...o.changedTouches].find((x) => x.identifier === s.touchId), !d || d.identifier !== s.touchId) return;
  } else
    d = o;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && i.emit("touchMoveOpposite", o);
    return;
  }
  const c = d.pageX, u = d.pageY;
  if (o.preventedByNestedSwiper) {
    r.startX = c, r.startY = u;
    return;
  }
  if (!i.allowTouchMove) {
    o.target.matches(s.focusableElements) || (i.allowClick = !1), s.isTouched && (Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u
    }), s.touchStartTime = de());
    return;
  }
  if (n.touchReleaseOnEdges && !n.loop)
    if (i.isVertical()) {
      if (u < r.startY && i.translate <= i.maxTranslate() || u > r.startY && i.translate >= i.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else {
      if (l && (c > r.startX && -i.translate <= i.maxTranslate() || c < r.startX && -i.translate >= i.minTranslate()))
        return;
      if (!l && (c < r.startX && i.translate <= i.maxTranslate() || c > r.startX && i.translate >= i.minTranslate()))
        return;
    }
  if (e.activeElement && e.activeElement.matches(s.focusableElements) && e.activeElement !== o.target && o.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && o.target === e.activeElement && o.target.matches(s.focusableElements)) {
    s.isMoved = !0, i.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && i.emit("touchMove", o), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = c, r.currentY = u;
  const f = r.currentX - r.startX, h = r.currentY - r.startY;
  if (i.params.threshold && Math.sqrt(f ** 2 + h ** 2) < i.params.threshold) return;
  if (typeof s.isScrolling > "u") {
    let x;
    i.isHorizontal() && r.currentY === r.startY || i.isVertical() && r.currentX === r.startX ? s.isScrolling = !1 : f * f + h * h >= 25 && (x = Math.atan2(Math.abs(h), Math.abs(f)) * 180 / Math.PI, s.isScrolling = i.isHorizontal() ? x > n.touchAngle : 90 - x > n.touchAngle);
  }
  if (s.isScrolling && i.emit("touchMoveOpposite", o), typeof s.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (s.startMoving = !0), s.isScrolling || o.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  i.allowClick = !1, !n.cssMode && o.cancelable && o.preventDefault(), n.touchMoveStopPropagation && !n.nested && o.stopPropagation();
  let p = i.isHorizontal() ? f : h, T = i.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  n.oneWayMovement && (p = Math.abs(p) * (l ? 1 : -1), T = Math.abs(T) * (l ? 1 : -1)), r.diff = p, p *= n.touchRatio, l && (p = -p, T = -T);
  const C = i.touchesDirection;
  i.swipeDirection = p > 0 ? "prev" : "next", i.touchesDirection = T > 0 ? "prev" : "next";
  const m = i.params.loop && !n.cssMode, g = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!s.isMoved) {
    if (m && g && i.loopFix({
      direction: i.swipeDirection
    }), s.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const x = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(x);
    }
    s.allowMomentumBounce = !1, n.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", o);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), n._loopSwapReset !== !1 && s.isMoved && s.allowThresholdMove && C !== i.touchesDirection && m && g && Math.abs(p) >= 1) {
    Object.assign(r, {
      startX: c,
      startY: u,
      currentX: c,
      currentY: u,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  i.emit("sliderMove", o), s.isMoved = !0, s.currentTranslate = p + s.startTranslate;
  let v = !0, E = n.resistanceRatio;
  if (n.touchReleaseOnEdges && (E = 0), p > 0 ? (m && g && s.allowThresholdMove && s.currentTranslate > (n.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > i.minTranslate() && (v = !1, n.resistance && (s.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + s.startTranslate + p) ** E))) : p < 0 && (m && g && s.allowThresholdMove && s.currentTranslate < (n.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (n.slidesPerView !== "auto" && i.slides.length - n.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (n.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(n.slidesPerView, 10)))
  }), s.currentTranslate < i.maxTranslate() && (v = !1, n.resistance && (s.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - s.startTranslate - p) ** E))), v && (o.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (s.currentTranslate = s.startTranslate), n.threshold > 0)
    if (Math.abs(p) > n.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, s.currentTranslate = s.startTranslate, r.diff = i.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !n.followFinger || n.cssMode || ((n.freeMode && n.freeMode.enabled && i.freeMode || n.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), n.freeMode && n.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(s.currentTranslate), i.setTranslate(s.currentTranslate));
}
function vi(t) {
  const e = this, i = e.touchEventsData;
  let s = t;
  s.originalEvent && (s = s.originalEvent);
  let n;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (n = [...s.changedTouches].find((x) => x.identifier === i.touchId), !n || n.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || s.pointerId !== i.pointerId) return;
    n = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  i.pointerId = null, i.touchId = null;
  const {
    params: l,
    touches: a,
    rtlTranslate: o,
    slidesGrid: d,
    enabled: c
  } = e;
  if (!c || !l.simulateTouch && s.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && e.emit("touchEnd", s), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && l.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  l.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const u = de(), f = u - i.touchStartTime;
  if (e.allowClick) {
    const x = s.path || s.composedPath && s.composedPath();
    e.updateClickedSlide(x && x[0] || s.target, x), e.emit("tap click", s), f < 300 && u - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", s);
  }
  if (i.lastClickTime = de(), qe(() => {
    e.destroyed || (e.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !e.swipeDirection || a.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let h;
  if (l.followFinger ? h = o ? e.translate : -e.translate : h = -i.currentTranslate, l.cssMode)
    return;
  if (l.freeMode && l.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: h
    });
    return;
  }
  const p = h >= -e.maxTranslate() && !e.params.loop;
  let T = 0, C = e.slidesSizesGrid[0];
  for (let x = 0; x < d.length; x += x < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
    const I = x < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    typeof d[x + I] < "u" ? (p || h >= d[x] && h < d[x + I]) && (T = x, C = d[x + I] - d[x]) : (p || h >= d[x]) && (T = x, C = d[d.length - 1] - d[d.length - 2]);
  }
  let m = null, g = null;
  l.rewind && (e.isBeginning ? g = l.virtual && l.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (m = 0));
  const v = (h - d[T]) / C, E = T < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
  if (f > l.longSwipesMs) {
    if (!l.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (v >= l.longSwipesRatio ? e.slideTo(l.rewind && e.isEnd ? m : T + E) : e.slideTo(T)), e.swipeDirection === "prev" && (v > 1 - l.longSwipesRatio ? e.slideTo(T + E) : g !== null && v < 0 && Math.abs(v) > l.longSwipesRatio ? e.slideTo(g) : e.slideTo(T));
  } else {
    if (!l.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl) ? s.target === e.navigation.nextEl ? e.slideTo(T + E) : e.slideTo(T) : (e.swipeDirection === "next" && e.slideTo(m !== null ? m : T + E), e.swipeDirection === "prev" && e.slideTo(g !== null ? g : T));
  }
}
function Ve() {
  const t = this, {
    params: e,
    el: i
  } = t;
  if (i && i.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: n,
    snapGrid: r
  } = t, l = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const a = l && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !a ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !l ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = n, t.allowSlideNext = s, t.params.watchOverflow && r !== t.snapGrid && t.checkOverflow();
}
function wi(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Si() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: i,
    enabled: s
  } = t;
  if (!s) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let n;
  const r = t.maxTranslate() - t.minTranslate();
  r === 0 ? n = 0 : n = (t.translate - t.minTranslate()) / r, n !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function bi(t) {
  const e = this;
  oe(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function Ti() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const Je = (t, e) => {
  const i = ie(), {
    params: s,
    el: n,
    wrapperEl: r,
    device: l
  } = t, a = !!s.nested, o = e === "on" ? "addEventListener" : "removeEventListener", d = e;
  !n || typeof n == "string" || (i[o]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: a
  }), n[o]("touchstart", t.onTouchStart, {
    passive: !1
  }), n[o]("pointerdown", t.onTouchStart, {
    passive: !1
  }), i[o]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), i[o]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), i[o]("touchend", t.onTouchEnd, {
    passive: !0
  }), i[o]("pointerup", t.onTouchEnd, {
    passive: !0
  }), i[o]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), i[o]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), i[o]("pointerout", t.onTouchEnd, {
    passive: !0
  }), i[o]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), i[o]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && n[o]("click", t.onClick, !0), s.cssMode && r[o]("scroll", t.onScroll), s.updateOnWindowResize ? t[d](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Ve, !0) : t[d]("observerUpdate", Ve, !0), n[o]("load", t.onLoad, {
    capture: !0
  }));
};
function xi() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = hi.bind(t), t.onTouchMove = gi.bind(t), t.onTouchEnd = vi.bind(t), t.onDocumentTouchStart = Ti.bind(t), e.cssMode && (t.onScroll = Si.bind(t)), t.onClick = wi.bind(t), t.onLoad = bi.bind(t), Je(t, "on");
}
function yi() {
  Je(this, "off");
}
var Ei = {
  attachEvents: xi,
  detachEvents: yi
};
const $e = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function Ci() {
  const t = this, {
    realIndex: e,
    initialized: i,
    params: s,
    el: n
  } = t, r = s.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const l = ie(), a = s.breakpointsBase === "window" || !s.breakpointsBase ? s.breakpointsBase : "container", o = ["window", "container"].includes(s.breakpointsBase) || !s.breakpointsBase ? t.el : l.querySelector(s.breakpointsBase), d = t.getBreakpoint(r, a, o);
  if (!d || t.currentBreakpoint === d) return;
  const u = (d in r ? r[d] : void 0) || t.originalParams, f = $e(t, s), h = $e(t, u), p = t.params.grabCursor, T = u.grabCursor, C = s.enabled;
  f && !h ? (n.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), t.emitContainerClasses()) : !f && h && (n.classList.add(`${s.containerModifierClass}grid`), (u.grid.fill && u.grid.fill === "column" || !u.grid.fill && s.grid.fill === "column") && n.classList.add(`${s.containerModifierClass}grid-column`), t.emitContainerClasses()), p && !T ? t.unsetGrabCursor() : !p && T && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((I) => {
    if (typeof u[I] > "u") return;
    const M = s[I] && s[I].enabled, b = u[I] && u[I].enabled;
    M && !b && t[I].disable(), !M && b && t[I].enable();
  });
  const m = u.direction && u.direction !== s.direction, g = s.loop && (u.slidesPerView !== s.slidesPerView || m), v = s.loop;
  m && i && t.changeDirection(), H(t.params, u);
  const E = t.params.enabled, x = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), C && !E ? t.disable() : !C && E && t.enable(), t.currentBreakpoint = d, t.emit("_beforeBreakpoint", u), i && (g ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !v && x ? (t.loopCreate(e), t.updateSlides()) : v && !x && t.loopDestroy()), t.emit("breakpoint", u);
}
function Pi(t, e, i) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !i) return;
  let s = !1;
  const n = k(), r = e === "window" ? n.innerHeight : i.clientHeight, l = Object.keys(t).map((a) => {
    if (typeof a == "string" && a.indexOf("@") === 0) {
      const o = parseFloat(a.substr(1));
      return {
        value: r * o,
        point: a
      };
    }
    return {
      value: a,
      point: a
    };
  });
  l.sort((a, o) => parseInt(a.value, 10) - parseInt(o.value, 10));
  for (let a = 0; a < l.length; a += 1) {
    const {
      point: o,
      value: d
    } = l[a];
    e === "window" ? n.matchMedia(`(min-width: ${d}px)`).matches && (s = o) : d <= i.clientWidth && (s = o);
  }
  return s || "max";
}
var Mi = {
  setBreakpoint: Ci,
  getBreakpoint: Pi
};
function Ii(t, e) {
  const i = [];
  return t.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((n) => {
      s[n] && i.push(e + n);
    }) : typeof s == "string" && i.push(e + s);
  }), i;
}
function Li() {
  const t = this, {
    classNames: e,
    params: i,
    rtl: s,
    el: n,
    device: r
  } = t, l = Ii(["initialized", i.direction, {
    "free-mode": t.params.freeMode && i.freeMode.enabled
  }, {
    autoheight: i.autoHeight
  }, {
    rtl: s
  }, {
    grid: i.grid && i.grid.rows > 1
  }, {
    "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": i.cssMode
  }, {
    centered: i.cssMode && i.centeredSlides
  }, {
    "watch-progress": i.watchSlidesProgress
  }], i.containerModifierClass);
  e.push(...l), n.classList.add(...e), t.emitContainerClasses();
}
function Oi() {
  const t = this, {
    el: e,
    classNames: i
  } = t;
  !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
}
var zi = {
  addClasses: Li,
  removeClasses: Oi
};
function _i() {
  const t = this, {
    isLocked: e,
    params: i
  } = t, {
    slidesOffsetBefore: s
  } = i;
  if (s) {
    const n = t.slides.length - 1, r = t.slidesGrid[n] + t.slidesSizesGrid[n] + s * 2;
    t.isLocked = t.size > r;
  } else
    t.isLocked = t.snapGrid.length === 1;
  i.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var Ai = {
  checkOverflow: _i
}, Ee = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Ni(t, e) {
  return function(s) {
    s === void 0 && (s = {});
    const n = Object.keys(s)[0], r = s[n];
    if (typeof r != "object" || r === null) {
      H(e, s);
      return;
    }
    if (t[n] === !0 && (t[n] = {
      enabled: !0
    }), n === "navigation" && t[n] && t[n].enabled && !t[n].prevEl && !t[n].nextEl && (t[n].auto = !0), ["pagination", "scrollbar"].indexOf(n) >= 0 && t[n] && t[n].enabled && !t[n].el && (t[n].auto = !0), !(n in t && "enabled" in r)) {
      H(e, s);
      return;
    }
    typeof t[n] == "object" && !("enabled" in t[n]) && (t[n].enabled = !0), t[n] || (t[n] = {
      enabled: !1
    }), H(e, s);
  };
}
const be = {
  eventsEmitter: zt,
  update: kt,
  translate: Yt,
  transition: Zt,
  slide: ai,
  loop: ci,
  grabCursor: pi,
  events: Ei,
  breakpoints: Mi,
  checkOverflow: Ai,
  classes: zi
}, Te = {};
let Pe = class X {
  constructor() {
    let e, i;
    for (var s = arguments.length, n = new Array(s), r = 0; r < s; r++)
      n[r] = arguments[r];
    n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? i = n[0] : [e, i] = n, i || (i = {}), i = H({}, i), e && !i.el && (i.el = e);
    const l = ie();
    if (i.el && typeof i.el == "string" && l.querySelectorAll(i.el).length > 1) {
      const c = [];
      return l.querySelectorAll(i.el).forEach((u) => {
        const f = H({}, i, {
          el: u
        });
        c.push(new X(f));
      }), c;
    }
    const a = this;
    a.__swiper__ = !0, a.support = Ue(), a.device = Ke({
      userAgent: i.userAgent
    }), a.browser = Qe(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], i.modules && Array.isArray(i.modules) && a.modules.push(...i.modules);
    const o = {};
    a.modules.forEach((c) => {
      c({
        params: i,
        swiper: a,
        extendParams: Ni(i, o),
        on: a.on.bind(a),
        once: a.once.bind(a),
        off: a.off.bind(a),
        emit: a.emit.bind(a)
      });
    });
    const d = H({}, Ee, o);
    return a.params = H({}, d, Te, i), a.originalParams = H({}, a.params), a.passedParams = H({}, i), a.params && a.params.on && Object.keys(a.params.on).forEach((c) => {
      a.on(c, a.params.on[c]);
    }), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
      enabled: a.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return a.params.direction === "horizontal";
      },
      isVertical() {
        return a.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: a.params.allowSlideNext,
      allowSlidePrev: a.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: a.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: a.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), a.emit("_swiper"), a.params.init && a.init(), a;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: i,
      params: s
    } = this, n = Y(i, `.${s.slideClass}, swiper-slide`), r = _e(n[0]);
    return _e(e) - r;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  getSlideIndexWhenGrid(e) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
  }
  recalcSlides() {
    const e = this, {
      slidesEl: i,
      params: s
    } = e;
    e.slides = Y(i, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, i) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const n = s.minTranslate(), l = (s.maxTranslate() - n) * e + n;
    s.translateTo(l, typeof i > "u" ? 0 : i), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = e.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(e) {
    const i = this;
    return i.destroyed ? "" : e.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = [];
    e.slides.forEach((s) => {
      const n = e.getSlideClasses(s);
      i.push({
        slideEl: s,
        classNames: n
      }), e.emit("_slideClass", s, n);
    }), e.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(e, i) {
    e === void 0 && (e = "current"), i === void 0 && (i = !1);
    const s = this, {
      params: n,
      slides: r,
      slidesGrid: l,
      slidesSizesGrid: a,
      size: o,
      activeIndex: d
    } = s;
    let c = 1;
    if (typeof n.slidesPerView == "number") return n.slidesPerView;
    if (n.centeredSlides) {
      let u = r[d] ? Math.ceil(r[d].swiperSlideSize) : 0, f;
      for (let h = d + 1; h < r.length; h += 1)
        r[h] && !f && (u += Math.ceil(r[h].swiperSlideSize), c += 1, u > o && (f = !0));
      for (let h = d - 1; h >= 0; h -= 1)
        r[h] && !f && (u += r[h].swiperSlideSize, c += 1, u > o && (f = !0));
    } else if (e === "current")
      for (let u = d + 1; u < r.length; u += 1)
        (i ? l[u] + a[u] - l[d] < o : l[u] - l[d] < o) && (c += 1);
    else
      for (let u = d - 1; u >= 0; u -= 1)
        l[d] - l[u] < o && (c += 1);
    return c;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: i,
      params: s
    } = e;
    s.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
      l.complete && oe(e, l);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function n() {
      const l = e.rtlTranslate ? e.translate * -1 : e.translate, a = Math.min(Math.max(l, e.maxTranslate()), e.minTranslate());
      e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      n(), s.autoHeight && e.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
        const l = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
        r = e.slideTo(l.length - 1, 0, !1, !0);
      } else
        r = e.slideTo(e.activeIndex, 0, !1, !0);
      r || n();
    }
    s.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, i) {
    i === void 0 && (i = !0);
    const s = this, n = s.params.direction;
    return e || (e = n === "horizontal" ? "vertical" : "horizontal"), e === n || e !== "horizontal" && e !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${n}`), s.el.classList.add(`${s.params.containerModifierClass}${e}`), s.emitContainerClasses(), s.params.direction = e, s.slides.forEach((r) => {
      e === "vertical" ? r.style.width = "" : r.style.height = "";
    }), s.emit("changeDirection"), i && s.update()), s;
  }
  changeLanguageDirection(e) {
    const i = this;
    i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(e) {
    const i = this;
    if (i.mounted) return !0;
    let s = e || i.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = i, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const n = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(n()) : Y(s, n())[0];
    return !l && i.params.createElements && (l = xe("div", i.params.wrapperClass), s.append(l), Y(s, `.${i.params.slideClass}`).forEach((a) => {
      l.append(a);
    })), Object.assign(i, {
      el: s,
      wrapperEl: l,
      slidesEl: i.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : l,
      hostEl: i.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || K(s, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || K(s, "direction") === "rtl"),
      wrongRTL: K(l, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const i = this;
    if (i.initialized || i.mount(e) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const n = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && n.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), n.forEach((r) => {
      r.complete ? oe(i, r) : r.addEventListener("load", (l) => {
        oe(i, l.target);
      });
    }), ye(i), i.initialized = !0, ye(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(e, i) {
    e === void 0 && (e = !0), i === void 0 && (i = !0);
    const s = this, {
      params: n,
      el: r,
      wrapperEl: l,
      slides: a
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), n.loop && s.loopDestroy(), i && (s.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), l && l.removeAttribute("style"), a && a.length && a.forEach((o) => {
      o.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), o.removeAttribute("style"), o.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((o) => {
      s.off(o);
    }), e !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), vt(s)), s.destroyed = !0), null;
  }
  static extendDefaults(e) {
    H(Te, e);
  }
  static get extendedDefaults() {
    return Te;
  }
  static get defaults() {
    return Ee;
  }
  static installModule(e) {
    X.prototype.__modules__ || (X.prototype.__modules__ = []);
    const i = X.prototype.__modules__;
    typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((i) => X.installModule(i)), X) : (X.installModule(e), X);
  }
};
Object.keys(be).forEach((t) => {
  Object.keys(be[t]).forEach((e) => {
    Pe.prototype[e] = be[t][e];
  });
});
Pe.use([Lt, Ot]);
const et = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function te(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function se(t, e) {
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((s) => i.indexOf(s) < 0).forEach((s) => {
    typeof t[s] > "u" ? t[s] = e[s] : te(e[s]) && te(t[s]) && Object.keys(e[s]).length > 0 ? e[s].__swiper__ ? t[s] = e[s] : se(t[s], e[s]) : t[s] = e[s];
  });
}
function tt(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function it(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function st(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function rt(t) {
  t === void 0 && (t = "");
  const e = t.split(" ").map((s) => s.trim()).filter((s) => !!s), i = [];
  return e.forEach((s) => {
    i.indexOf(s) < 0 && i.push(s);
  }), i.join(" ");
}
function Gi(t) {
  return t === void 0 && (t = ""), t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
function Di(t) {
  let {
    swiper: e,
    slides: i,
    passedParams: s,
    changedParams: n,
    nextEl: r,
    prevEl: l,
    scrollbarEl: a,
    paginationEl: o
  } = t;
  const d = n.filter((w) => w !== "children" && w !== "direction" && w !== "wrapperClass"), {
    params: c,
    pagination: u,
    navigation: f,
    scrollbar: h,
    virtual: p,
    thumbs: T
  } = e;
  let C, m, g, v, E, x, I, M;
  n.includes("thumbs") && s.thumbs && s.thumbs.swiper && !s.thumbs.swiper.destroyed && c.thumbs && (!c.thumbs.swiper || c.thumbs.swiper.destroyed) && (C = !0), n.includes("controller") && s.controller && s.controller.control && c.controller && !c.controller.control && (m = !0), n.includes("pagination") && s.pagination && (s.pagination.el || o) && (c.pagination || c.pagination === !1) && u && !u.el && (g = !0), n.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || a) && (c.scrollbar || c.scrollbar === !1) && h && !h.el && (v = !0), n.includes("navigation") && s.navigation && (s.navigation.prevEl || l) && (s.navigation.nextEl || r) && (c.navigation || c.navigation === !1) && f && !f.prevEl && !f.nextEl && (E = !0);
  const b = (w) => {
    e[w] && (e[w].destroy(), w === "navigation" ? (e.isElement && (e[w].prevEl.remove(), e[w].nextEl.remove()), c[w].prevEl = void 0, c[w].nextEl = void 0, e[w].prevEl = void 0, e[w].nextEl = void 0) : (e.isElement && e[w].el.remove(), c[w].el = void 0, e[w].el = void 0));
  };
  n.includes("loop") && e.isElement && (c.loop && !s.loop ? x = !0 : !c.loop && s.loop ? I = !0 : M = !0), d.forEach((w) => {
    if (te(c[w]) && te(s[w]))
      Object.assign(c[w], s[w]), (w === "navigation" || w === "pagination" || w === "scrollbar") && "enabled" in s[w] && !s[w].enabled && b(w);
    else {
      const S = s[w];
      (S === !0 || S === !1) && (w === "navigation" || w === "pagination" || w === "scrollbar") ? S === !1 && b(w) : c[w] = s[w];
    }
  }), d.includes("controller") && !m && e.controller && e.controller.control && c.controller && c.controller.control && (e.controller.control = c.controller.control), n.includes("children") && i && p && c.virtual.enabled ? (p.slides = i, p.update(!0)) : n.includes("virtual") && p && c.virtual.enabled && (i && (p.slides = i), p.update(!0)), n.includes("children") && i && c.loop && (M = !0), C && T.init() && T.update(!0), m && (e.controller.control = c.controller.control), g && (e.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-pagination"), o.part.add("pagination"), e.el.appendChild(o)), o && (c.pagination.el = o), u.init(), u.render(), u.update()), v && (e.isElement && (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-scrollbar"), a.part.add("scrollbar"), e.el.appendChild(a)), a && (c.scrollbar.el = a), h.init(), h.updateSize(), h.setTranslate()), E && (e.isElement && ((!r || typeof r == "string") && (r = document.createElement("div"), r.classList.add("swiper-button-next"), Ne(r, e.hostEl.constructor.nextButtonSvg), r.part.add("button-next"), e.el.appendChild(r)), (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-button-prev"), Ne(l, e.hostEl.constructor.prevButtonSvg), l.part.add("button-prev"), e.el.appendChild(l))), r && (c.navigation.nextEl = r), l && (c.navigation.prevEl = l), f.init(), f.update()), n.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext), n.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev), n.includes("direction") && e.changeDirection(s.direction, !1), (x || M) && e.loopDestroy(), (I || M) && e.loopCreate(), e.update();
}
function Vi(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = !0);
  const i = {
    on: {}
  }, s = {}, n = {};
  se(i, Ee), i._emitClasses = !0, i.init = !1;
  const r = {}, l = et.map((o) => o.replace(/_/, "")), a = Object.assign({}, t);
  return Object.keys(a).forEach((o) => {
    typeof t[o] > "u" || (l.indexOf(o) >= 0 ? te(t[o]) ? (i[o] = {}, n[o] = {}, se(i[o], t[o]), se(n[o], t[o])) : (i[o] = t[o], n[o] = t[o]) : o.search(/on[A-Z]/) === 0 && typeof t[o] == "function" ? e ? s[`${o[2].toLowerCase()}${o.substr(3)}`] = t[o] : i.on[`${o[2].toLowerCase()}${o.substr(3)}`] = t[o] : r[o] = t[o]);
  }), ["navigation", "pagination", "scrollbar"].forEach((o) => {
    i[o] === !0 && (i[o] = {}), i[o] === !1 && delete i[o];
  }), {
    params: i,
    passedParams: n,
    rest: r,
    events: s
  };
}
function $i(t, e) {
  let {
    el: i,
    nextEl: s,
    prevEl: n,
    paginationEl: r,
    scrollbarEl: l,
    swiper: a
  } = t;
  tt(e) && s && n && (a.params.navigation.nextEl = s, a.originalParams.navigation.nextEl = s, a.params.navigation.prevEl = n, a.originalParams.navigation.prevEl = n), it(e) && r && (a.params.pagination.el = r, a.originalParams.pagination.el = r), st(e) && l && (a.params.scrollbar.el = l, a.originalParams.scrollbar.el = l), a.init(i);
}
function Bi(t, e, i, s, n) {
  const r = [];
  if (!e) return r;
  const l = (o) => {
    r.indexOf(o) < 0 && r.push(o);
  };
  if (i && s) {
    const o = s.map(n), d = i.map(n);
    o.join("") !== d.join("") && l("children"), s.length !== i.length && l("children");
  }
  return et.filter((o) => o[0] === "_").map((o) => o.replace(/_/, "")).forEach((o) => {
    if (o in t && o in e)
      if (te(t[o]) && te(e[o])) {
        const d = Object.keys(t[o]), c = Object.keys(e[o]);
        d.length !== c.length ? l(o) : (d.forEach((u) => {
          t[o][u] !== e[o][u] && l(o);
        }), c.forEach((u) => {
          t[o][u] !== e[o][u] && l(o);
        }));
      } else t[o] !== e[o] && l(o);
  }), r;
}
const Fi = (t) => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.emit("_virtualUpdated"), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function ue() {
  return ue = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var s in i)
        Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s]);
    }
    return t;
  }, ue.apply(this, arguments);
}
function nt(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function at(t) {
  const e = [];
  return V.Children.toArray(t).forEach((i) => {
    nt(i) ? e.push(i) : i.props && i.props.children && at(i.props.children).forEach((s) => e.push(s));
  }), e;
}
function Ri(t) {
  const e = [], i = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return V.Children.toArray(t).forEach((s) => {
    if (nt(s))
      e.push(s);
    else if (s.props && s.props.slot && i[s.props.slot])
      i[s.props.slot].push(s);
    else if (s.props && s.props.children) {
      const n = at(s.props.children);
      n.length > 0 ? n.forEach((r) => e.push(r)) : i["container-end"].push(s);
    } else
      i["container-end"].push(s);
  }), {
    slides: e,
    slots: i
  };
}
function ki(t, e, i) {
  if (!i) return null;
  const s = (c) => {
    let u = c;
    return c < 0 ? u = e.length + c : u >= e.length && (u = u - e.length), u;
  }, n = t.isHorizontal() ? {
    [t.rtlTranslate ? "right" : "left"]: `${i.offset}px`
  } : {
    top: `${i.offset}px`
  }, {
    from: r,
    to: l
  } = i, a = t.params.loop ? -e.length : 0, o = t.params.loop ? e.length * 2 : e.length, d = [];
  for (let c = a; c < o; c += 1)
    c >= r && c <= l && d.push(e[s(c)]);
  return d.map((c, u) => /* @__PURE__ */ V.cloneElement(c, {
    swiper: t,
    style: n,
    key: c.props.virtualIndex || c.key || `slide-${u}`
  }));
}
function re(t, e) {
  return typeof window > "u" ? U(t, e) : ct(t, e);
}
const Be = /* @__PURE__ */ We(null), Hi = /* @__PURE__ */ We(null), pe = /* @__PURE__ */ je(function(t, e) {
  let {
    className: i,
    tag: s = "div",
    wrapperTag: n = "div",
    children: r,
    onSwiper: l,
    ...a
  } = t === void 0 ? {} : t, o = !1;
  const [d, c] = Q("swiper"), [u, f] = Q(null), [h, p] = Q(!1), T = R(!1), C = R(null), m = R(null), g = R(null), v = R(null), E = R(null), x = R(null), I = R(null), M = R(null), {
    params: b,
    passedParams: w,
    rest: S,
    events: y
  } = Vi(a), {
    slides: P,
    slots: z
  } = Ri(r), $ = () => {
    p(!h);
  };
  Object.assign(b.on, {
    _containerClasses(_, B) {
      c(B);
    }
  });
  const F = () => {
    Object.assign(b.on, y), o = !0;
    const _ = {
      ...b
    };
    if (delete _.wrapperClass, m.current = new Pe(_), m.current.virtual && m.current.params.virtual.enabled) {
      m.current.virtual.slides = P;
      const B = {
        cache: !1,
        slides: P,
        renderExternal: f,
        renderExternalUpdate: !1
      };
      se(m.current.params.virtual, B), se(m.current.originalParams.virtual, B);
    }
  };
  C.current || F(), m.current && m.current.on("_beforeBreakpoint", $);
  const L = () => {
    o || !y || !m.current || Object.keys(y).forEach((_) => {
      m.current.on(_, y[_]);
    });
  }, A = () => {
    !y || !m.current || Object.keys(y).forEach((_) => {
      m.current.off(_, y[_]);
    });
  };
  U(() => () => {
    m.current && m.current.off("_beforeBreakpoint", $);
  }), U(() => {
    !T.current && m.current && (m.current.emitSlidesClasses(), T.current = !0);
  }), re(() => {
    if (e && (e.current = C.current), !!C.current)
      return m.current.destroyed && F(), $i({
        el: C.current,
        nextEl: E.current,
        prevEl: x.current,
        paginationEl: I.current,
        scrollbarEl: M.current,
        swiper: m.current
      }, b), l && !m.current.destroyed && l(m.current), () => {
        m.current && !m.current.destroyed && m.current.destroy(!0, !1);
      };
  }, []), re(() => {
    L();
    const _ = Bi(w, g.current, P, v.current, (B) => B.key);
    return g.current = w, v.current = P, _.length && m.current && !m.current.destroyed && Di({
      swiper: m.current,
      slides: P,
      passedParams: w,
      changedParams: _,
      nextEl: E.current,
      prevEl: x.current,
      scrollbarEl: M.current,
      paginationEl: I.current
    }), () => {
      A();
    };
  }), re(() => {
    Fi(m.current);
  }, [u]);
  function G() {
    return b.virtual ? ki(m.current, P, u) : P.map((_, B) => /* @__PURE__ */ V.cloneElement(_, {
      swiper: m.current,
      swiperSlideIndex: B
    }));
  }
  return /* @__PURE__ */ V.createElement(s, ue({
    ref: C,
    className: rt(`${d}${i ? ` ${i}` : ""}`)
  }, S), /* @__PURE__ */ V.createElement(Hi.Provider, {
    value: m.current
  }, z["container-start"], /* @__PURE__ */ V.createElement(n, {
    className: Gi(b.wrapperClass)
  }, z["wrapper-start"], G(), z["wrapper-end"]), tt(b) && /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement("div", {
    ref: x,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ V.createElement("div", {
    ref: E,
    className: "swiper-button-next"
  })), st(b) && /* @__PURE__ */ V.createElement("div", {
    ref: M,
    className: "swiper-scrollbar"
  }), it(b) && /* @__PURE__ */ V.createElement("div", {
    ref: I,
    className: "swiper-pagination"
  }), z["container-end"]));
});
pe.displayName = "Swiper";
const me = /* @__PURE__ */ je(function(t, e) {
  let {
    tag: i = "div",
    children: s,
    className: n = "",
    swiper: r,
    zoom: l,
    lazy: a,
    virtualIndex: o,
    swiperSlideIndex: d,
    ...c
  } = t === void 0 ? {} : t;
  const u = R(null), [f, h] = Q("swiper-slide"), [p, T] = Q(!1);
  function C(E, x, I) {
    x === u.current && h(I);
  }
  re(() => {
    if (typeof d < "u" && (u.current.swiperSlideIndex = d), e && (e.current = u.current), !(!u.current || !r)) {
      if (r.destroyed) {
        f !== "swiper-slide" && h("swiper-slide");
        return;
      }
      return r.on("_slideClass", C), () => {
        r && r.off("_slideClass", C);
      };
    }
  }), re(() => {
    r && u.current && !r.destroyed && h(r.getSlideClasses(u.current));
  }, [r]);
  const m = {
    isActive: f.indexOf("swiper-slide-active") >= 0,
    isVisible: f.indexOf("swiper-slide-visible") >= 0,
    isPrev: f.indexOf("swiper-slide-prev") >= 0,
    isNext: f.indexOf("swiper-slide-next") >= 0
  }, g = () => typeof s == "function" ? s(m) : s, v = () => {
    T(!0);
  };
  return /* @__PURE__ */ V.createElement(i, ue({
    ref: u,
    className: rt(`${f}${n ? ` ${n}` : ""}`),
    "data-swiper-slide-index": o,
    onLoad: v
  }, c), l && /* @__PURE__ */ V.createElement(Be.Provider, {
    value: m
  }, /* @__PURE__ */ V.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof l == "number" ? l : void 0
  }, g(), a && !p && /* @__PURE__ */ V.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !l && /* @__PURE__ */ V.createElement(Be.Provider, {
    value: m
  }, g(), a && !p && /* @__PURE__ */ V.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
me.displayName = "SwiperSlide";
const Me = {
  // 이전, 다음 슬라이드 미리 로드.
  lazyPreloadPrevNext: 1,
  // 초기화 시 콜백 실행 여부.
  runCallbacksOnInit: !1,
  // 슬라이드 당 보여지는 수.
  slidesPerView: "auto",
  // 슬라이드 간격.
  spaceBetween: 10,
  // 슬라이드 이동 임계값.
  threshold: 10
}, lt = ({
  selectedIndex: t,
  setSelectedIndex: e,
  items: i,
  onTabSelected: s,
  onTabImpression: n,
  className: r,
  swiperOptions: l,
  shapeType: a = "outlined",
  deviceType: o,
  noIndicator: d = !1,
  swiperProps: c
}) => {
  const u = o === "etc", {
    spaceBetween: f = 8,
    slidesOffsetBefore: h = 16,
    slidesOffsetAfter: p = 16,
    slideStepCount: T = 1,
    ...C
  } = l ?? {}, { onSwiper: m, onSlideChange: g, ...v } = c ?? {}, E = ut(), x = R(null), I = R([]), M = ee(() => `chip-tab-${E}`, [E]), b = u && !d, [w, S] = Q(!1), [y, P] = Q(!1), [z, $] = Q(!1), F = ee(
    () => ({
      ...Me,
      spaceBetween: f,
      slidesOffsetBefore: h,
      slidesOffsetAfter: p,
      threshold: 4,
      initialSlide: t,
      centeredSlides: !0,
      centerInsufficientSlides: !1,
      centeredSlidesBounds: !0,
      ...C
    }),
    [C, p, h, f]
  ), L = ee(() => i.map((O) => typeof O == "string" ? { label: O } : O), [i]), A = (O) => {
    var W;
    const D = L[O];
    e(O), s == null || s(O, D.label), (W = x.current) == null || W.slideTo(O);
  }, G = () => {
    var O;
    T === 1 ? (O = x.current) == null || O.slidePrev() : B("prev");
  }, _ = () => {
    var O;
    T === 1 ? (O = x.current) == null || O.slideNext() : B("next");
  }, B = (O) => {
    if (!x.current) return;
    const D = x.current.realIndex, W = O === "prev" ? D - T : D + T;
    x.current.slideTo(W), P(x.current.isBeginning), $(x.current.isEnd);
  }, J = (O) => {
    b && S(O);
  };
  return U(() => {
    if (!n) return;
    const O = new IntersectionObserver(
      (D) => {
        D.forEach((W) => {
          if (W.isIntersecting) {
            const Le = I.current.findIndex((dt) => dt === W.target);
            Le !== -1 && (n(Le), O.unobserve(W.target));
          }
        });
      },
      { threshold: 0.5 }
    );
    return I.current.forEach((D) => {
      D && O.observe(D);
    }), () => {
      O.disconnect();
    };
  }, [n, I]), U(() => {
    var O, D;
    P(((O = x.current) == null ? void 0 : O.isBeginning) ?? !1), $(((D = x.current) == null ? void 0 : D.isEnd) ?? !1), document.fonts.ready.then(() => {
      x.current && x.current.updateSlides();
    }).catch(() => {
    });
  }, []), /* @__PURE__ */ j(
    "div",
    {
      className: q("relative w-full", r),
      id: M,
      onMouseEnter: () => {
        J(!0);
      },
      onMouseLeave: () => {
        J(!1);
      },
      children: [
        /* @__PURE__ */ N(
          pe,
          {
            ...F,
            onSlideChange: (O) => {
              P(O.isBeginning), $(O.isEnd), g == null || g(O);
            },
            onSwiper: (O) => {
              x.current = O, m == null || m(O);
            },
            ...v,
            children: L.map((O, D) => /* @__PURE__ */ j(me, { className: "!w-fit", "data-index": D, tabIndex: 0, children: [
              /* @__PURE__ */ N(
                pt,
                {
                  "data-index": D,
                  disabled: !!O.disabled,
                  onClick: () => {
                    A(D);
                  },
                  ref: (W) => I.current[D] = W,
                  selected: t === D,
                  size: u ? "large" : "medium",
                  theme: a,
                  children: /* @__PURE__ */ j("span", { className: "relative", children: [
                    O.label,
                    !!O.showDotBadge && /* @__PURE__ */ N(ne, {})
                  ] })
                },
                `${O.label}_${D}`
              ),
              O.extraElement
            ] }, `${O.label}_${D}`))
          }
        ),
        !!b && /* @__PURE__ */ N(
          ft,
          {
            arrowProps: {
              left: {
                hidden: y,
                onClick: G
              },
              right: {
                hidden: z,
                onClick: _
              }
            },
            hidden: !w,
            id: M,
            positionStrategy: "fixed",
            size: "xsmall"
          }
        )
      ]
    }
  );
};
lt.displayName = "NDS.ChipTab";
const Fe = Z(
  [
    "h-44 relative flex items-center justify-center",
    "rounded-capsule  cursor-pointer select-none",
    "disabled:pointer-events-none disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        active: "pointer-events-none",
        inactive: "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
      },
      shape: {
        underline: ["rounded-none bg-static-transparent disabled:bg-static-transparent px-4 py-0 min-w-32"]
      }
    },
    compoundVariants: [
      {
        state: "active",
        shape: "underline",
        className: "text-text-neutral-main border-b-2  border-line-neutral-main typography-body-14-bold"
      },
      {
        state: "inactive",
        shape: "underline",
        className: "border-b-2 border-transparent typography-body-14-regular text-text-neutral-main bg-static-transparent"
      }
    ],
    defaultVariants: {
      state: "inactive",
      shape: "underline"
    }
  }
), ot = ({
  selectedIndex: t,
  setSelectedIndex: e,
  items: i,
  onTabSelected: s,
  className: n,
  slidesSpaceBetween: r,
  slidesOffsetBefore: l = 16,
  slidesOffsetAfter: a = 16,
  slidesDuration: o = 300,
  tabType: d = "scrollable",
  shapeType: c,
  dotBadgeIndexes: u
}) => {
  const f = R(null), h = R([]), p = ee(
    () => ({
      ...Me,
      itemType: "tab",
      spaceBetween: void 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      threshold: 4,
      centeredSlides: !1
    }),
    [a, l]
  ), T = (m) => {
    var E;
    const g = Number(m.currentTarget.dataset.index), v = i[g];
    e(g), s == null || s(g, v), m.stopPropagation(), C(g), (E = f.current) != null && E.wrapperEl && (f.current.wrapperEl.style.transitionDuration = `${o}ms`);
  }, C = (m) => {
    var S, y;
    const g = (S = h.current[m]) == null ? void 0 : S.parentElement;
    if (!((y = f.current) != null && y.wrapperEl) || !g)
      return;
    const v = f.current.width, E = f.current.wrapperEl.scrollWidth, x = g.offsetLeft, I = g.offsetWidth;
    if (E <= v)
      return;
    const M = -(x + I / 2 - v / 2), b = v - E - a, w = Math.min(0, Math.max(M, b));
    f.current.wrapperEl.style.transitionDuration = `${o}ms`, f.current.setTranslate(w);
  };
  return U(() => {
    C(t);
  }, [t]), U(() => {
    d !== "fixed" && document.fonts.ready.then(() => {
      f.current && f.current.updateSlides();
    }).catch(() => {
    });
  }, []), d === "fixed" ? /* @__PURE__ */ N(
    "div",
    {
      className: q("box-content flex", n),
      style: {
        gap: `${r ?? 0}px`
      },
      children: i.map((m, g) => /* @__PURE__ */ j(
        "button",
        {
          className: q(
            "w-full min-w-68 pc:min-w-84",
            Fe({
              state: t === g ? "active" : "inactive",
              shape: c
            })
          ),
          "data-index": g,
          onClick: (v) => {
            T(v);
          },
          ref: (v) => h.current[g] = v,
          tabIndex: 0,
          type: "button",
          children: [
            /* @__PURE__ */ N("span", { className: "invisible overflow-hidden whitespace-nowrap font-bold", children: m }),
            /* @__PURE__ */ N("span", { className: "absolute inset-0 flex items-center justify-center overflow-hidden whitespace-nowrap", children: /* @__PURE__ */ j("span", { className: "relative", children: [
              m,
              !!(u != null && u.includes(g + 1)) && /* @__PURE__ */ N(ne, {})
            ] }) })
          ]
        },
        `${m}_${g}`
      ))
    }
  ) : /* @__PURE__ */ N(
    pe,
    {
      className: q("w-full", n),
      ...p,
      onSwiper: (m) => {
        f.current = m, setTimeout(() => {
          var g;
          (g = f.current) != null && g.wrapperEl && (f.current.wrapperEl.style.transitionDuration = `${o}ms`);
        }, 0);
      },
      children: i.map((m, g) => /* @__PURE__ */ N(
        me,
        {
          className: "!w-fit max-w-full last:mr-0",
          "data-index": g,
          onClick: (v) => {
            T(v);
          },
          style: {
            paddingLeft: g === 0 ? `${l}px` : `${r ?? 8}px`,
            paddingRight: g === i.length - 1 ? `${a}px` : void 0
          },
          tabIndex: 0,
          children: /* @__PURE__ */ j(
            "div",
            {
              className: Fe({ state: t === g ? "active" : "inactive", shape: c }),
              ref: (v) => h.current[g] = v,
              children: [
                /* @__PURE__ */ N("span", { className: "invisible overflow-hidden whitespace-nowrap font-bold", children: m }),
                /* @__PURE__ */ N("span", { className: "absolute inset-0 flex items-center justify-center whitespace-nowrap", children: /* @__PURE__ */ j("span", { className: "relative", children: [
                  m,
                  !!(u != null && u.includes(g + 1)) && /* @__PURE__ */ N(ne, {})
                ] }) })
              ]
            }
          )
        },
        `${m}_${g}`
      ))
    }
  );
};
ot.displayName = "NDS.LegacyTab";
const ji = Z(
  [
    "relative flex items-center justify-center rounded-capsule",
    "cursor-pointer select-none box-border",
    "disabled:pointer-events-none disabled:cursor-not-allowed"
  ],
  {
    variants: {
      size: {
        medium: ["min-h-36 px-16 typography-body-13-regular"],
        large: ["min-h-42 px-20 typography-subtitle-16-regular"]
      },
      pcSize: {
        medium: ["pc:min-h-36 pc:px-16 pc:typography-body-13-regular"],
        large: ["pc:min-h-42 pc:px-20 pc:typography-subtitle-16-regular"]
      },
      state: {
        active: "!font-bold pointer-events-none",
        inactive: "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
      },
      shape: {
        filled_capsule: "bg-fill-neutral-weak disabled:bg-fill-neutral-weak disabled:text-interaction-neutral-disable-main",
        outlined_capsule: "bg-static-transparent disabled:bg-static-transparent border border-line-neutral-main"
      }
    },
    compoundVariants: [
      {
        state: "active",
        shape: "filled_capsule",
        className: "!text-static-white !bg-static-black"
      },
      {
        state: "active",
        shape: "outlined_capsule",
        className: "bg-static-white text-text-neutral-main"
      },
      {
        state: "inactive",
        shape: "outlined_capsule",
        className: "text-text-neutral-sub bg-static-transparent border-transparent"
      }
    ],
    defaultVariants: {
      state: "inactive",
      shape: "filled_capsule"
    }
  }
), Wi = Z(["box-content flex"], {
  variants: {
    size: {
      medium: [],
      large: []
    },
    pcSize: {
      medium: [],
      large: []
    },
    shape: {
      filled_capsule: "",
      outlined_capsule: "w-fit rounded-full bg-fill-neutral-weak",
      underline: "px-16",
      underline_primary: "px-16"
    }
  },
  compoundVariants: [
    {
      shape: "outlined_capsule",
      size: "medium",
      className: "p-2"
    },
    {
      shape: "outlined_capsule",
      size: "large",
      className: "p-4"
    },
    {
      shape: "outlined_capsule",
      pcSize: "medium",
      className: "pc:p-2"
    },
    {
      shape: "outlined_capsule",
      pcSize: "large",
      className: "pc:p-4"
    }
  ]
}), Xi = Z([], {
  variants: {
    size: {
      medium: ["pl-16"],
      large: ["pl-0"]
    },
    pcSize: {
      medium: ["pc:pl-16"],
      large: ["pc:pl-0"]
    },
    shape: {
      filled_capsule: "!pl-16",
      outlined_capsule: "!pl-16",
      underline: "",
      underline_primary: ""
    }
  }
}), qi = Z([], {
  variants: {
    size: {
      medium: ["pr-16"],
      large: ["pr-0"]
    },
    pcSize: {
      medium: ["pc:pr-16"],
      large: ["pc:pr-0"]
    },
    shape: {
      filled_capsule: "!pr-16",
      outlined_capsule: "!pr-16",
      underline: "",
      underline_primary: ""
    }
  }
}), Yi = Z([], {
  variants: {
    size: {
      medium: ["pl-6"],
      large: ["pl-8"]
    },
    pcSize: {
      medium: ["pc:pl-6"],
      large: ["pc:pl-8"]
    },
    shape: {
      filled_capsule: "",
      outlined_capsule: "",
      underline: "!pl-16",
      underline_primary: "!pl-16"
    }
  }
}), Ui = Z(
  [
    "relative flex items-center justify-center p-4 min-w-32 rounded-none",
    "cursor-pointer select-none text-text-neutral-main box-border",
    "disabled:pointer-events-none disabled:cursor-not-allowed",
    "bg-static-transparent disabled:bg-static-transparent "
  ],
  {
    variants: {
      size: {
        medium: ["min-h-44 typography-body-14-regular"],
        large: ["min-h-52 typography-subtitle-16-regular"]
      },
      pcSize: {
        medium: ["pc:min-h-44 pc:typography-body-14-regular"],
        large: ["pc:min-h-52 pc:typography-subtitle-16-regular"]
      },
      state: {
        active: "border-b-2 border-line-neutral-main !font-bold",
        inactive: "border-b border-transparent hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1"
      },
      shape: {
        underline: "",
        underline_primary: ""
      }
    },
    compoundVariants: [
      {
        state: "active",
        shape: "underline_primary",
        className: "text-text-primary-main border-line-primary-main"
      }
    ],
    defaultVariants: {
      state: "inactive"
    }
  }
), Re = Z([], {
  variants: {
    isUnderLine: {
      true: 'relative z-0 !box-border before:absolute before:inset-x-0 before:bottom-0 before:z-0 before:h-px before:bg-line-neutral-weak2 before:content-[""]',
      false: ""
    }
  }
}), ke = 16, He = {
  before: { mobile: "--tab-offset-before-mobile", pc: "--tab-offset-before-pc" },
  after: { mobile: "--tab-offset-after-mobile", pc: "--tab-offset-after-pc" }
}, Ki = {
  before: "paddingLeft",
  after: "paddingRight"
}, Qi = {
  before: "pl-[var(--tab-offset-before-mobile)] pc:pl-[var(--tab-offset-before-pc)]",
  after: "pr-[var(--tab-offset-after-mobile)] pc:pr-[var(--tab-offset-after-pc)]"
};
function Zi(t, e) {
  return typeof e == "number" ? { [Ki[t]]: `${e}px` } : e && typeof e == "object" ? {
    [He[t].mobile]: `${e.mobile ?? ke}px`,
    [He[t].pc]: `${e.pc ?? ke}px`
  } : {};
}
function Ji(t, e) {
  return e && typeof e == "object" ? Qi[t] : "";
}
function fe(t, e) {
  return {
    className: Ji(t, e),
    style: Zi(t, e)
  };
}
function es({
  shapeType: t,
  slidesSpaceBetween: e,
  slidesOffsetBefore: i,
  slidesOffsetAfter: s
}) {
  const n = t !== "outlined_capsule" ? fe("before", i) : void 0, r = t !== "outlined_capsule" ? fe("after", s) : void 0;
  return {
    className: [n == null ? void 0 : n.className, r == null ? void 0 : r.className].filter(Boolean).join(" "),
    style: {
      gap: `${e ?? 0}px`,
      ...n == null ? void 0 : n.style,
      ...r == null ? void 0 : r.style
    }
  };
}
const Ie = ({
  selectedIndex: t,
  setSelectedIndex: e,
  items: i,
  onTabSelected: s,
  className: n,
  slidesSpaceBetween: r,
  slidesOffsetBefore: l,
  slidesOffsetAfter: a,
  slidesDuration: o = 300,
  tabType: d = "scrollable",
  shapeType: c = "filled_capsule",
  buttonClassName: u,
  size: f,
  hasUnderLineDivider: h = !1
}) => {
  const p = R(null), T = R([]), C = c === "underline" || c === "underline_primary", m = ee(
    () => ({
      ...Me,
      itemType: "tab",
      spaceBetween: void 0,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      threshold: 4,
      centeredSlides: !1
    }),
    []
  ), g = ee(() => i.map((b) => typeof b == "string" ? { label: b } : b), [i]), v = ee(
    () => mt({
      property: f,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "large" }
    }),
    [f]
  ), E = Oe(
    (b) => C ? Ui({
      state: b,
      shape: c,
      ...v
    }) : ji({
      state: b,
      shape: c,
      ...v
    }),
    [C, c, v]
  ), x = Oe(
    (b) => {
      const w = b === 0, S = b === g.length - 1, y = {}, P = ["!w-fit max-w-full last:mr-0"];
      if (w || (r !== void 0 ? y.paddingLeft = `${r}px` : P.push(Yi({ shape: c, ...v }))), w)
        if (l === void 0)
          P.push(Xi({ shape: c, ...v }));
        else {
          const z = fe("before", l);
          P.push(z.className), Object.assign(y, z.style);
        }
      if (S)
        if (a === void 0)
          P.push(qi({ shape: c, ...v }));
        else {
          const z = fe("after", a);
          P.push(z.className), Object.assign(y, z.style);
        }
      return {
        className: q(...P),
        style: Object.keys(y).length > 0 ? y : void 0
      };
    },
    [v, c, r, l, a, g.length]
  ), I = (b) => {
    var y;
    const w = Number(b.currentTarget.dataset.index), S = g[w];
    e(w), s == null || s(w, S.label), b.stopPropagation(), M(w), (y = p.current) != null && y.wrapperEl && (p.current.wrapperEl.style.transitionDuration = `${o}ms`);
  }, M = (b) => {
    var _, B, J;
    const w = (_ = T.current[b]) == null ? void 0 : _.parentElement;
    if (!((B = p.current) != null && B.wrapperEl) || !w)
      return;
    const S = p.current.width, y = p.current.wrapperEl.scrollWidth, P = w.offsetLeft, z = w.offsetWidth;
    if (y <= S)
      return;
    const $ = -(P + z / 2 - S / 2), F = (J = T.current[g.length - 1]) == null ? void 0 : J.parentElement, L = typeof window < "u" && F && Number.parseFloat(window.getComputedStyle(F).paddingRight) || 0, A = S - y - L, G = Math.min(0, Math.max($, A));
    p.current.wrapperEl.style.transitionDuration = `${o}ms`, p.current.setTranslate(G);
  };
  if (U(() => {
    M(t);
  }, [t]), U(() => {
    d !== "fixed" && document.fonts.ready.then(() => {
      p.current && p.current.update();
    }).catch(() => {
    });
  }, []), d === "fixed") {
    const b = es({
      shapeType: c,
      slidesSpaceBetween: r,
      slidesOffsetBefore: l,
      slidesOffsetAfter: a
    });
    return /* @__PURE__ */ N(
      "div",
      {
        className: q(
          Wi({ shape: c, ...v }),
          b.className,
          Re({ isUnderLine: h }),
          n
        ),
        style: b.style,
        children: g.map((w, S) => /* @__PURE__ */ j(
          "button",
          {
            className: q(
              E(t === S ? "active" : "inactive"),
              {
                // underline 타입일 경우 전체 width로 설정, w-full은 underline 타입일 때만 적용
                "w-full": C
              },
              u
            ),
            "data-index": S,
            onClick: (y) => {
              I(y);
            },
            tabIndex: 0,
            type: "button",
            children: [
              /* @__PURE__ */ N("span", { className: "invisible overflow-hidden whitespace-nowrap font-bold", children: w.label }),
              /* @__PURE__ */ N("span", { className: "absolute inset-0 flex items-center justify-center overflow-hidden whitespace-nowrap", children: /* @__PURE__ */ j("span", { className: "relative", children: [
                w.label,
                !!w.showDotBadge && /* @__PURE__ */ N(ne, {})
              ] }) }),
              w.extraElement
            ]
          },
          `${w.label}_${S.toString()}`
        ))
      }
    );
  }
  return /* @__PURE__ */ N(
    pe,
    {
      className: q("w-full", Re({ isUnderLine: h }), n),
      ...m,
      onSwiper: (b) => {
        p.current = b, setTimeout(() => {
          var w;
          (w = p.current) != null && w.wrapperEl && (p.current.wrapperEl.style.transitionDuration = `${o}ms`);
        }, 0);
      },
      children: g.map((b, w) => {
        const S = x(w);
        return /* @__PURE__ */ N(
          me,
          {
            className: S.className,
            "data-index": w,
            onClick: (y) => {
              I(y);
            },
            style: S.style,
            tabIndex: 0,
            children: /* @__PURE__ */ j(
              "div",
              {
                className: q(E(t === w ? "active" : "inactive"), u),
                ref: (y) => T.current[w] = y,
                children: [
                  /* @__PURE__ */ N("span", { className: "invisible overflow-hidden whitespace-nowrap font-bold", children: b.label }),
                  /* @__PURE__ */ N("span", { className: "absolute inset-0 flex items-center justify-center whitespace-nowrap", children: /* @__PURE__ */ j("span", { className: "relative", children: [
                    b.label,
                    !!b.showDotBadge && /* @__PURE__ */ N(ne, {})
                  ] }) }),
                  b.extraElement
                ]
              }
            )
          },
          `${b.label}_${w}`
        );
      })
    }
  );
};
Ie.Legacy = ot;
Ie.Chip = lt;
Ie.displayName = "NDS.Tab";
export {
  Ie as T
};
